// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:07.880Z
// Property: Polo Run Apartments (ID: 6767906449165619)
// Collections: 29 amenities, 6 floorplans (live), 36 photos, 67 POIs, 2 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165619",
  "property_external_id": "5m5lmfq",
  "property_zillow_url": "https://www.zillow.com/apartments/tulsa-ok/polo-run-apartments/5XhzQq/",
  "property_apartments_url": "https://www.apartments.com/polo-run-apartments-tulsa-ok/5m5lmfq/",
  "property_google_business_url": "https://www.google.com/maps/place/Polo+Run+Apartments/data=!4m2!3m1!1s0x0:0x9af74ff3257a1bb3?sa=X&ved=2ahUKEwi7sszF_bySAxUdIkQIHTUIMowQ_BJ6BAgPEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "8794409771",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "polo-run-apartments",
  "property_name": "Polo Run Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/polo-run/",
  "property_domain": null,
  "property_address": "7027 South Joplin",
  "property_full_address": "7027 South Joplin, Tulsa, OK, 74136",
  "property_address_1": "7027 South Joplin",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74136",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0627",
  "property_address_longitude": "-95.9116",
  "property_email": "polorun@caseusa.com",
  "property_phone": "(539) 239-3828",
  "property_call_tracking_phone": "855-686-1044",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Polo Run Apartments in Tulsa, Oklahoma, where comfort meets convenience. Choose from spacious one and two-bedroom floor plans equipped with modern amenities like a refreshing pool, fitness center, and dog park. Unwind at our clubhouse or explore scenic walking trails—your ideal home awaits! Schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Discover Your Perfect Home at Polo Run Apartments in Tulsa, Oklahoma**\n\nWelcome to Polo Run Apartments, where comfort meets convenience! Our vibrant community offers a variety of thoughtfully designed floor plans, including spacious one and two-bedroom apartments tailored to fit your lifestyle. Each residence features modern amenities such as air conditioning, walk-in closets, and fully-equipped kitchens with refrigerators, dishwashers, and microwaves. Enjoy relaxing weekends on your private balcony or patio, taking advantage of picturesque views and the serenity of nature.\n\nPolo Run Apartments is more than just a place to live; it’s a lifestyle. Dive into our sparkling pool on sunny days, or stay active in our fitness center or on our basketball court. Families will love our dedicated playground while pet owners appreciate our sizable dog park. For those who work from home or need a quiet place to study, our business center and online services make it easy to stay productive.\n\nOur gated community ensures a secure living environment, complemented by on-site maintenance and management for your peace of mind. Enjoy the convenience of package service, laundry facilities, and 24-hour access, making everyday life effortless.\n\nUnwind in our clubhouse, sip coffee on the sundeck, or gather with friends in our picnic area with grills for weekend barbecues. With walking and biking trails surrounding the property, you'll have plenty of opportunities to explore the outdoors.\n\nAt Polo Run Apartments, your ideal living experience awaits! Find your new home today—browse our availability or schedule a tour to visit our community and discover all that we have to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fb44b-8bef-7751-a7bd-7c5144c13890.webp",
  "property_featured_image_media": {
    "alt_text": "The exterior of the Polo Run apartment building entrance and parking lot.",
    "public_id": "019fb44b-8bef-7751-a7bd-7c5144c13890",
    "storage_key": "property/6767906449165619/019fb44b-8bef-7751-a7bd-7c5144c13890.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "178",
  "property_year_built": "1985",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.19101123595506",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets per household. Breed restrictions apply.",
  "property_pet_policy_description": "Cats and dogs allowed. Maximum of two pets per household. No weight limit. Breed restrictions apply. One-time non‑refundable fee: $500 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://polorunapartmentstulsa.securecafe.com/onlineleasing/polo-run-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://polorunapartmentstulsa.securecafe.com/residentservices/polo-run-apartments/userlogin.aspx",
  "property_apply_now_url": "https://polorunapartmentstulsa.securecafe.com/onlineleasing/polo-run-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-4906-7542-8939-3709978cf315.webp",
  "property_primary_logo_media": {
    "alt_text": "Polo Run Apartment Homes logo",
    "public_id": "019cfb45-4906-7542-8939-3709978cf315",
    "storage_key": "property/6767906449165619/019cfb45-4906-7542-8939-3709978cf315.webp",
    "width": 531,
    "height": 332
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb46-2b06-770f-a181-7e437cb5dae2.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb46-2b06-770f-a181-7e437cb5dae2",
    "storage_key": "property/6767906449165619/019cfb46-2b06-770f-a181-7e437cb5dae2.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-4906-7542-8939-3709978cf315.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Polo Run Apartment Homes logo",
    "public_id": "019cfb45-4906-7542-8939-3709978cf315",
    "storage_key": "property/6767906449165619/019cfb45-4906-7542-8939-3709978cf315.webp",
    "width": 531,
    "height": 332
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb46-590b-7595-af80-811c1c43905c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Polo Run Apartment Homes logo",
    "public_id": "019cfb46-590b-7595-af80-811c1c43905c",
    "storage_key": "property/6767906449165619/019cfb46-590b-7595-af80-811c1c43905c.webp",
    "width": 531,
    "height": 332
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#6d6c62",
  "property_secondary_color": "#00adbb",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#e2daca",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "700 - 950",
  "property_sqft_min": "700",
  "property_sqft_max": "950",
  "property_price_range": "929 - 1089",
  "property_price_min": "929",
  "property_price_max": "1089",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/PoloRunTulsa/posts/welcome-to-polo-run-a-stunning-community-of-apartments-and-townhomes-right-here-/1460463762009460/",
  "property_instagram_url": "https://www.instagram.com/polorunaptstulsa/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJJ_A9mW-StocRsxt6JfNP95o",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/polo-run-tulsa",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Polo Run Apartments",
  "property_home_romance_title": "Embrace Joy in Your New Apartment Home Today",
  "property_home_amenities_blurb": "Welcome to Polo Run Apartments in vibrant Tulsa, Oklahoma! Our community blends comfort and convenience with spacious one and two-bedroom floor plans, a sparkling pool, and a welcoming clubhouse. Enjoy outdoor living spaces, a dog park, and fitness amenities, all designed for your lifestyle. Come see what makes us a unique place to call home!",
  "property_home_floorplans_blurb": "At Polo Run Apartments in Tulsa, Oklahoma, you’ll find impeccably designed one and two-bedroom homes tailored to your lifestyle. Each floor plan offers spacious living, modern amenities, and a welcoming community vibe. Ready to elevate your living experience? Browse our available apartments and uncover your ideal floor plan today!",
  "property_home_gallery_blurb": "At Polo Run Apartments in Tulsa, your ideal lifestyle awaits with spacious one and two-bedroom layouts. Enjoy modern amenities like a refreshing pool, fitness center, and dog park, plus gatherings at the clubhouse or sundeck. Picture yourself living here, where comfort meets community in every detail.",
  "property_home_neighborhood_blurb": "Welcome to Polo Run Apartments in vibrant Tulsa, Oklahoma! Enjoy spacious one and two-bedroom floor plans surrounded by a wealth of local treasures. With easy access to cultural gems like the Philbrook Museum of Art, the Oklahoma Aquarium, and the stunning Gathering Place, adventure awaits just outside your door!",
  "property_home_reviews_blurb": "At Polo Run Apartments in Tulsa, Oklahoma, our residents truly appreciate the warmth of our community. One delighted tenant shares, \"The office and maintenance staff have been tremendous...their true caring when you talk to them has been wonderful.\" Experience the comfort and camaraderie we offer—see what our residents have to say!",
  "property_neighborhood_blurb": "Nestled in the heart of Tulsa, Polo Run Apartments offers a prime location near vibrant attractions. Stroll through the serene Woodland Hills Mall, soak in art at the Philbrook Museum, or unleash excitement at Urban Air Trampoline Park. Experience the best of city living paired with exquisite amenities. Explore what surrounds us!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Polo Run Apartments in Tulsa, Oklahoma, exceptional living meets vibrant community life. Lounge by the refreshing pool, energize in the fitness center, or enjoy sunny picnics on the sundeck. With spacious floor plans, a dog park, and scenic walking trails, every day offers an opportunity for relaxation and adventure!",
  "property_applynow_blurb": "At Polo Run Apartments in Tulsa, your dream home awaits! Choose from cozy one and two-bedroom floor plans with stylish amenities like refreshing pools, a fitness center, and picturesque walking trails. Enjoy modern conveniences and a vibrant community vibe. Lease online today and elevate your lifestyle in Tulsa!",
  "property_contactus_blurb": "At Polo Run Apartments in Tulsa, Oklahoma, find the perfect one or two-bedroom floor plan tailored to your lifestyle. Whether you’re seeking cozy solitude or a spacious living experience, we have options to fit your needs. Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Polo Run Apartments in Tulsa, Oklahoma, our diverse floor plans cater to every lifestyle, featuring chic one-bedroom and spacious two-bedroom options. Got questions? Our FAQs page is your go-to resource for everything you need to know about our vibrant community. Visit now to uncover the answers!",
  "property_floorplans_blurb": "At Polo Run Apartments in Tulsa, Oklahoma, thoughtful design meets modern living. Choose from our spacious one and two-bedroom floor plans, each crafted for comfort and style. Ready to make a change? Browse our available apartment homes and find the ideal layout that fits your lifestyle perfectly!",
  "property_gallery_blurb": "At Polo Run Apartments in Tulsa, Oklahoma, every moment can be a new adventure. Envision sunny afternoons by our sparkling pool, invigorating workouts in the fitness center, or relaxing strolls on scenic biking trails. With fantastic amenities and spacious floor plans, your vibrant lifestyle awaits. Picture yourself living here!",
  "property_interactivemap_blurb": "At Polo Run Apartments in Tulsa, Oklahoma, choose from spacious one and two-bedroom floor plans designed for comfort and convenience. Enjoy resort-style amenities like a refreshing pool, a state-of-the-art fitness center, and serene walking/biking trails. Use our interactive community map to find your perfect new home today!",
  "property_pets_blurb": "At Polo Run Apartments in Tulsa, OK, your furry friends are more than welcome! Enjoy a pet-friendly lifestyle with no weight limits and space for two pets. With scenic surroundings and spacious living, find the perfect place to create cherished memories with your pets by your side.",
  "property_referafriend_blurb": "At Polo Run Apartments in Tulsa, Oklahoma, exceptional living awaits! Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Share the joy of your exceptional home—refer a friend and build a welcoming community around you. Great friends make great neighbors; let's grow together today!",
  "property_residentaccess_blurb": "Welcome to Polo Run Apartments in Tulsa, Oklahoma, where our spacious one- and two-bedroom floor plans cater to your lifestyle. Enjoy seamless living with convenient online resident access, making it easy to pay rent, schedule maintenance, and manage all your needs with just a click. Get started today!",
  "property_reviews_blurb": "At Polo Run Apartments in Tulsa, our residents appreciate the cozy, quiet charm of our small community. One resident noted, \"The office and maintenance staff have been tremendous,\" highlighting our dedicated team. With soundproof insulation and a prime location just minutes from the mall, you’ll feel right at home! Read more about what our residents say!",
  "property_created_at": "1753982389231",
  "property_scheduletour_blurb": "At Polo Run Apartments in Tulsa, Oklahoma, our thoughtfully designed one and two-bedroom floor plans cater to your every need. Embrace a vibrant lifestyle surrounded by modern comforts and exceptional amenities. Schedule a tour today and hear firsthand why our residents love calling Polo Run home!",
  "property_thankyou_blurb": "Thank you for reaching out to Polo Run Apartments in beautiful Tulsa, Oklahoma! We offer spacious one and two-bedroom floor plans designed for comfort and style. Keep an eye on your inbox—our team will be in touch soon to help you find your perfect home. Welcome to your future!",
  "property_virtualtours_blurb": "At Polo Run Apartments in Tulsa, Oklahoma, experience spacious living with our one and two-bedroom floor plans designed for your comfort. Immerse yourself in our vibrant community—take a virtual tour today and envision your future home in a place where style meets convenience! ",
  "property_copyright": "2025 All Rights Reserved. Polo Run Apartments",
  "property_seo_title_home": "Polo Run Apartments |  Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Discover comfort and style at Polo Run Apartments in Tulsa. Enjoy spacious floor plans and stunning amenities. Your ideal home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Discover your ideal home at Polo Run Apartments in Tulsa, OK. Choose from stylish one and two-bedroom floor plans for modern living!",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at Polo Run Apartments in Tulsa! Dive into our pool, work out in the fitness center, or unwind at our dog park. Your comfort awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "Experience luxury living at Polo Run Apartments in Tulsa, featuring a pool, fitness center, dog park, and scenic trails. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Polo Run Apartments Apartments",
  "property_seo_description_virtualtours": "Experience Polo Run Apartments in Tulsa! Take a virtual tour to explore our inviting one and two-bedroom floor plans. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Polo Run Apartments Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Polo Run Apartments in Tulsa! Use our interactive map to explore layouts, amenities like a pool & fitness center, and pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood around Polo Run Apartments in Tulsa, OK. From local favorites to hidden gems, discover what makes our community unique!",
  "property_seo_title_contact": "Contact Us | Polo Run Apartments",
  "property_seo_description_contact": "Reach out to Polo Run Apartments in Tulsa! Whether it's one or two bedrooms, our leasing team is here to help answer all your questions. Connect with us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Find answers to your questions about Polo Run Apartments in Tulsa. From amenities to floor plans, our FAQs have you covered for a seamless living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Experience life at Polo Run Apartments in Tulsa—check out our residents' reviews and see why comfort and community come together here!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Find your perfect space at Polo Run Apartments in Tulsa! Enjoy modern amenities, spacious floor plans, and a vibrant community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Polo Run Apartments",
  "property_seo_description_residentaccess": "Login to your Polo Run Apartments portal to pay rent, request maintenance, and stay connected with your vibrant community in Tulsa, Oklahoma.",
  "property_seo_title_referafriend": "Refer A Friend | Polo Run Apartments",
  "property_seo_description_referafriend": "Great friends make great neighbors at Polo Run Apartments! Refer a friend in Tulsa and enjoy exclusive perks. Share the experience of vibrant living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Polo Run Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Polo Run Apartments in Tulsa! Schedule your tour today and find your ideal home amidst beautiful amenities and vibrant community vibes.",
  "property_seo_title_privacy": "Privacy Policy | Polo Run Apartments",
  "property_seo_description_privacy": "At Polo Run Apartments, your privacy matters. Discover how we safeguard your information for your peace of mind in Tulsa. View our policy.",
  "property_seo_title_accessibility": "Website Accessibility | Polo Run Apartments",
  "property_seo_description_accessibility": "At Polo Run Apartments in Tulsa, we prioritize accessibility for all. Join us in creating an inclusive community where comfort and convenience meet.",
  "property_seo_title_sitemap": "Sitemap | Polo Run Apartments",
  "property_seo_description_sitemap": "Unlock the layout of Polo Run Apartments in Tulsa! Navigate our sitemap to find your dream home and connect with a vibrant community tailored for you.",
  "property_seo_title_thankyou": "Thank You | Polo Run Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! A Polo Run Apartments team member will be in touch soon to help you find your ideal home in Tulsa's vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865591621",
  "amenities": [
    {
      "id": "custom_d6411fff-b329-4323-8b1b-4d20d33c7f00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic Area with Barbecue Grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_035afd22-0a55-42eb-8610-2c0f5b6ef1a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3b72f3e-09de-4c85-a289-0ba11e874990",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d9b492d0-154a-4871-a06c-7431446b8dff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Limited‑Access Gates",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_509bf35a-0a3b-4cc2-9c9d-f9886eb887e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Fitness Center with Free Weights",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1544d059-601f-4da2-8631-a5a86b3fa4b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Onsite Laundry Facility",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_65969e3d-2a6f-4026-9a1b-0cb549db6250",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Night Patrol",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb0e0ee4-b3c7-442b-8a2e-08894ac369d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6ea47cf-4c0b-4e59-9def-1403840ea8d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_24f7d9d3-d8d8-4431-98fe-27a635543a94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Package Receiving",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6dff8c54-dc57-4406-b883-c15c541e4f8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Electronic Payments Accepted",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6db364e7-9da7-4011-9237-e0b4f3484466",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab619a62-ca1d-43e3-90f4-9290b873533b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc3af878-1869-4951-90bb-4d966ff4ebaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Gazebo",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_62c664f1-b439-45ef-80de-2bbb59b3396c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9a5cb214-9e13-45a4-b66e-a8de576ec4d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7816b614-d746-426b-98b1-ae023b288aee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_347aa866-1688-43ad-8090-03138f44a972",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e643fc8-fab6-467b-9723-15a36b81e1f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_94bb7e12-0bcf-421c-a622-49bae6aaf3c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_633aa642-c941-408c-9e80-ac8fbdabe60f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Outside Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02078253-7c0d-4e5d-b85a-1e34490575e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Burning Fireplace with Mantel",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1276a3cb-b6f0-4d6c-b8fe-fa63986120e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_20a85e49-7e6e-4e35-9d91-2a67b3b6b483",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bea32ad2-79d8-4784-bb29-932de6aa5e0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Frost‑Free Refrigerator with Ice Maker",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_71824d1b-2832-4c1c-a649-a6da3620463f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_55d3386e-4673-4811-ae79-050aabfc2701",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "All‑Electric Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5a97d867-4d78-4679-b60b-5cc69f9ce3df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Stove",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_44fff54b-1fe0-42b8-acc6-7860b84a2ed7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Pantry",
      "amount": "false",
      "description": "In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4d376d21-11ec-495a-9cd8-ee7f1fe4dc97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-2a9f-7718-8776-350cf980116c.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelving.",
        "public_id": "019fa4a4-2a9f-7718-8776-350cf980116c",
        "storage_key": "property/6767906449165619/019fa4a4-2a9f-7718-8776-350cf980116c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c379f03-2dfb-4a43-9919-bd384a23396f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-16a4-773e-b434-710470e61837.webp",
      "image_media": {
        "alt_text": "Laundry room with washer, dryer, hamper, and laundry symbols sign.",
        "public_id": "019fa4a4-16a4-773e-b434-710470e61837",
        "storage_key": "property/6767906449165619/019fa4a4-16a4-773e-b434-710470e61837.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities make chores a breeze.",
      "link": "",
      "alt_text": "Laundry room with washer, dryer, hamper, and laundry symbols sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_55100e93-6cdc-4dab-90c6-a6403f403540",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-13fe-770b-940f-1f333334d83c.webp",
      "image_media": {
        "alt_text": "Bedroom with dresser, mirror, ceiling fan, closet, and bathroom entrance.",
        "public_id": "019fa4a4-13fe-770b-940f-1f333334d83c",
        "storage_key": "property/6767906449165619/019fa4a4-13fe-770b-940f-1f333334d83c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a wooden dresser with a mirror and decor, a comfortable bed with accent pillows, a ceiling fan, and access to a closet and bathroom.",
      "link": "",
      "alt_text": "Bedroom with dresser, mirror, ceiling fan, closet, and bathroom entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4bdb6ee0-e71f-4eb0-b54e-55c35fa165c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-211a-74be-8318-1adeb9cba0df.webp",
      "image_media": {
        "alt_text": "A bathroom with a white tub, shower, toilet, and striped shower curtain.",
        "public_id": "019fa4a4-211a-74be-8318-1adeb9cba0df",
        "storage_key": "property/6767906449165619/019fa4a4-211a-74be-8318-1adeb9cba0df.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Enjoy this clean and functional bathroom, featuring a white tub and shower, a modern toilet, and a stylish striped shower curtain.",
      "link": "",
      "alt_text": "A bathroom with a white tub, shower, toilet, and striped shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_74ca1bcd-9bc0-4e0a-930f-22f7e1ae2140",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-0bb2-714e-a787-68274a487a81.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-sized bed, nightstands, and a ceiling fan.",
        "public_id": "019fa4a4-0bb2-714e-a787-68274a487a81",
        "storage_key": "property/6767906449165619/019fa4a4-0bb2-714e-a787-68274a487a81.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush king-sized bed, elegant nightstands, and a convenient ceiling fan for ultimate comfort.",
      "link": "",
      "alt_text": "Cozy bedroom with a king-sized bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0214773a-1395-4f17-b617-82a300064a2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-0a4a-757d-a41b-145167e9f3da.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, light wood cabinets, and granite countertops.",
        "public_id": "019fa4a4-0a4a-757d-a41b-145167e9f3da",
        "storage_key": "property/6767906449165619/019fa4a4-0a4a-757d-a41b-145167e9f3da.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white appliances, ample cabinet space, and a double sink. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with white appliances, light wood cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3bf2161b-da65-4988-baa4-57b908e1326c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-0a2b-7408-841c-206cdf69124a.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, brown headboard, and decorative wall art.",
        "public_id": "019fa4a4-0a2b-7408-841c-206cdf69124a",
        "storage_key": "property/6767906449165619/019fa4a4-0a2b-7408-841c-206cdf69124a.webp",
        "width": 2700,
        "height": 1802
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen bed and tasteful decor for a serene atmosphere.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-sized bed, brown headboard, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_800b5713-93d0-4c9e-a2e1-a86cca8b9fba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-2001-7141-b4d3-1d0e03217447.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, mirror, toilet, and bathtub.",
        "public_id": "019fa4a4-2001-7141-b4d3-1d0e03217447",
        "storage_key": "property/6767906449165619/019fa4a4-2001-7141-b4d3-1d0e03217447.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a spacious vanity with ample counter space, a large mirror, a private toilet, and a bathtub with a shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, mirror, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fafcacd8-0097-47f2-a6fd-df01117cbf2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-0b8a-7641-8afb-51b0e1a90edb.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, microwave, stove, refrigerator, and ample cabinet space.",
        "public_id": "019fa4a4-0b8a-7641-8afb-51b0e1a90edb",
        "storage_key": "property/6767906449165619/019fa4a4-0b8a-7641-8afb-51b0e1a90edb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A well-equipped kitchen featuring white appliances including a microwave, stove, and refrigerator, with plenty of cabinet storage and granite-style countertops.",
      "link": "",
      "alt_text": "Kitchen with white appliances, microwave, stove, refrigerator, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7aa004c1-ce83-4946-ac3f-3f6d99be162b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-09bf-70f8-8fa7-84b64429c5bf.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and closet",
        "public_id": "019fa4a4-09bf-70f8-8fa7-84b64429c5bf",
        "storage_key": "property/6767906449165619/019fa4a4-09bf-70f8-8fa7-84b64429c5bf.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bathroom with a double vanity, ample counter space, and a walk-in closet. A modern and clean design perfect for any apartment.",
      "link": "",
      "alt_text": "Bathroom vanity with sink and closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d36b5d6d-6a72-4498-8209-c73e342c726d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a3-915d-7409-bbdb-fd73a22bc261.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with dual sinks and wood cabinets, leading to a toilet and shower.",
        "public_id": "019fa4a3-915d-7409-bbdb-fd73a22bc261",
        "storage_key": "property/6767906449165619/019fa4a3-915d-7409-bbdb-fd73a22bc261.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample counter space, complemented by a separate area with a toilet and shower, all designed for comfort and style.",
      "link": "",
      "alt_text": "Bathroom vanity with dual sinks and wood cabinets, leading to a toilet and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4aa7e83a-cd3d-4efb-9cd6-d6f5008f8747",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a3-8f26-77f6-ba70-ff2dba543ffd.webp",
      "image_media": {
        "alt_text": "Queen bed with yellow and white bedding, two windows with blue curtains and blinds, a potted plant, and a wicker chair.",
        "public_id": "019fa4a3-8f26-77f6-ba70-ff2dba543ffd",
        "storage_key": "property/6767906449165619/019fa4a3-8f26-77f6-ba70-ff2dba543ffd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a queen-size bed with cozy linens, ample natural light, and a charming reading nook with a wicker chair.",
      "link": "",
      "alt_text": "Queen bed with yellow and white bedding, two windows with blue curtains and blinds, a potted plant, and a wicker chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8689fb2-41a0-48db-9ee0-7327bae8c4e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a3-8626-717f-9f5b-f74f4c8b5a57.webp",
      "image_media": {
        "alt_text": "Washer and dryer set in a laundry closet.",
        "public_id": "019fa4a3-8626-717f-9f5b-f74f4c8b5a57",
        "storage_key": "property/6767906449165619/019fa4a3-8626-717f-9f5b-f74f4c8b5a57.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry days.",
      "link": "",
      "alt_text": "Washer and dryer set in a laundry closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3b4cf1b3-fac9-43e5-b912-75088989a41b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a3-81e8-74dc-9793-7cf1cf354431.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, dishwasher, sink, stove, refrigerator, and washer/dryer.",
        "public_id": "019fa4a3-81e8-74dc-9793-7cf1cf354431",
        "storage_key": "property/6767906449165619/019fa4a3-81e8-74dc-9793-7cf1cf354431.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring wood cabinetry, a dishwasher, and ample counter space. Includes a refrigerator and a washer/dryer for your convenience.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, dishwasher, sink, stove, refrigerator, and washer/dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_46f6d23f-98c8-429f-8e38-08f95c82193e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a3-70f8-700c-a28a-cc00c927341e.webp",
      "image_media": {
        "alt_text": "Cozy living room with a fireplace, TV, and access to an outdoor patio.",
        "public_id": "019fa4a3-70f8-700c-a28a-cc00c927341e",
        "storage_key": "property/6767906449165619/019fa4a3-70f8-700c-a28a-cc00c927341e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room featuring a warm fireplace, a large TV for entertainment, and direct access to your private outdoor patio.",
      "link": "",
      "alt_text": "Cozy living room with a fireplace, TV, and access to an outdoor patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_25ab7bb8-f12c-4319-bfd4-37f606d3557c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a3-7083-7530-a975-ce5bb79e57ba.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, granite countertops, a dishwasher, refrigerator, stove, and washer/dryer.",
        "public_id": "019fa4a3-7083-7530-a975-ce5bb79e57ba",
        "storage_key": "property/6767906449165619/019fa4a3-7083-7530-a975-ce5bb79e57ba.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This apartment kitchen features ample storage with wooden cabinets and granite countertops. It includes essential appliances like a dishwasher, refrigerator, and stove, plus an in-unit washer and dryer for convenience.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, granite countertops, a dishwasher, refrigerator, stove, and washer/dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3d02ab8-74dd-4bb4-b3e3-c5d4790ba1a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a3-6592-72eb-a997-96724e59ef1b.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and two yellow chairs, featuring modern decor.",
        "public_id": "019fa4a3-6592-72eb-a997-96724e59ef1b",
        "storage_key": "property/6767906449165619/019fa4a3-6592-72eb-a997-96724e59ef1b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining area, perfect for intimate gatherings, featuring a round table and stylish yellow seating.",
      "link": "",
      "alt_text": "Dining area with a round table and two yellow chairs, featuring modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e42dfb80-2750-40de-aa97-41f4c891e84c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a3-63a4-732d-80c9-9f80aa5379d3.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, TV, and kitchen counter.",
        "public_id": "019fa4a3-63a4-732d-80c9-9f80aa5379d3",
        "storage_key": "property/6767906449165619/019fa4a3-63a4-732d-80c9-9f80aa5379d3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, entertainment center, and an open view to the kitchen area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, TV, and kitchen counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6197596a-01f7-4c5c-b8e0-fb8505ddf0bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a3-6355-763c-99f1-1efa8ca2ba6c.webp",
      "image_media": {
        "alt_text": "Kitchenette area with bar stools and a high-top table with chairs, accented by modern wall art.",
        "public_id": "019fa4a3-6355-763c-99f1-1efa8ca2ba6c",
        "storage_key": "property/6767906449165619/019fa4a3-6355-763c-99f1-1efa8ca2ba6c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a casual meal or entertain guests in this stylish kitchenette area featuring bar seating and a cozy dining nook, perfect for any apartment lifestyle.",
      "link": "",
      "alt_text": "Kitchenette area with bar stools and a high-top table with chairs, accented by modern wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4fa5ff6a-3422-4b4b-a722-5d887df25a3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a3-6387-7468-97e8-f4d0df0f7ac7.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and TV, view into a bedroom.",
        "public_id": "019fa4a3-6387-7468-97e8-f4d0df0f7ac7",
        "storage_key": "property/6767906449165619/019fa4a3-6387-7468-97e8-f4d0df0f7ac7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, TV, and comfortable seating, with an adjacent bedroom visible.",
      "link": "",
      "alt_text": "Living room with a fireplace and TV, view into a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99c0a4d2-77f3-47f9-aa29-850a9eaa8fe9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a3-6323-735a-b48e-e0e3bd19b562.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, coffee table, and door.",
        "public_id": "019fa4a3-6323-735a-b48e-e0e3bd19b562",
        "storage_key": "property/6767906449165619/019fa4a3-6323-735a-b48e-e0e3bd19b562.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable sofa, and coffee table, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with fireplace, sofa, coffee table, and door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ff1d9bda-5a13-46b8-bf85-efc340cffad4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-9757-726c-ab2e-c9da985d8086.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with table and chairs, next to a grill, with apartment buildings in the background.",
        "public_id": "019fa4a2-9757-726c-ab2e-c9da985d8086",
        "storage_key": "property/6767906449165619/019fa4a2-9757-726c-ab2e-c9da985d8086.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with this communal grilling and dining area, perfect for gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor seating area with table and chairs, next to a grill, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_659448b6-d381-4770-b527-684a6c856d3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-66eb-734c-a07b-8ae0b22a49b7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fa4a2-66eb-734c-a07b-8ae0b22a49b7",
        "storage_key": "property/6767906449165619/019fa4a2-66eb-734c-a07b-8ae0b22a49b7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0dcc29b-acc2-4532-8fc4-d3a1496121ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-7d8e-75e8-8840-4638a44c5139.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables on the deck, adjacent to apartment buildings.",
        "public_id": "019fa4a2-7d8e-75e8-8840-4638a44c5139",
        "storage_key": "property/6767906449165619/019fa4a2-7d8e-75e8-8840-4638a44c5139.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge seating and tables perfect for relaxing.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables on the deck, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea4aa427-b5b8-4054-b484-46e9a8fa848c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-7c75-7630-aac3-c5a714e73e45.webp",
      "image_media": {
        "alt_text": "Community swimming pool with lounge chairs and modern building in the background.",
        "public_id": "019fa4a2-7c75-7630-aac3-c5a714e73e45",
        "storage_key": "property/6767906449165619/019fa4a2-7c75-7630-aac3-c5a714e73e45.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and modern architecture. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Community swimming pool with lounge chairs and modern building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_376df511-8cfb-4916-81e0-cc7eb34235ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-64b4-765c-944d-b403898481db.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a parking lot and two cars.",
        "public_id": "019fa4a2-64b4-765c-944d-b403898481db",
        "storage_key": "property/6767906449165619/019fa4a2-64b4-765c-944d-b403898481db.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the apartment building exterior, featuring a brick facade, balconies, and a paved parking lot with yellow lane markings. Two cars are parked in the lot.",
      "link": "",
      "alt_text": "Apartment building exterior with a parking lot and two cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_197f4ddc-8996-46ce-8622-99151fec86ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-657a-774f-9a13-1360e90a7c55.webp",
      "image_media": {
        "alt_text": "Polo Run Apartment Homes monument sign and building exterior",
        "public_id": "019fa4a2-657a-774f-9a13-1360e90a7c55",
        "storage_key": "property/6767906449165619/019fa4a2-657a-774f-9a13-1360e90a7c55.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Welcome to Polo Run Apartment Homes, featuring a prominent monument sign with the property name and logo.",
      "link": "",
      "alt_text": "Polo Run Apartment Homes monument sign and building exterior",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f848a054-de47-48cd-8f3b-38b179ee099c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-897a-7319-9725-d72d3f70d634.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick and siding, showing balconies, parked cars, and landscaping.",
        "public_id": "019fa4a2-897a-7319-9725-d72d3f70d634",
        "storage_key": "property/6767906449165619/019fa4a2-897a-7319-9725-d72d3f70d634.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings, showcasing the architectural details and the surrounding community grounds.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with brick and siding, showing balconies, parked cars, and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d085005e-e056-407b-ba91-13b95db98c41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-6e12-71cb-b551-85dee7b9a1bb.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables and chairs on a wooden deck, adjacent to apartment buildings.",
        "public_id": "019fa4a2-6e12-71cb-b551-85dee7b9a1bb",
        "storage_key": "property/6767906449165619/019fa4a2-6e12-71cb-b551-85dee7b9a1bb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation on our spacious wooden deck, complete with tables, chairs, and umbrellas. A perfect spot to unwind near the apartment buildings.",
      "link": "",
      "alt_text": "Outdoor seating area with tables and chairs on a wooden deck, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2b500d02-4d55-40ab-bde0-a19e6e9e0d99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-4528-76ca-b54b-549069569986.webp",
      "image_media": {
        "alt_text": "Polo Run apartment building exterior with modern signage.",
        "public_id": "019fa4a2-4528-76ca-b54b-549069569986",
        "storage_key": "property/6767906449165619/019fa4a2-4528-76ca-b54b-549069569986.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Welcome to Polo Run, where contemporary design meets comfortable living. This exterior view showcases our modern signage and beautiful landscaping.",
      "link": "",
      "alt_text": "Polo Run apartment building exterior with modern signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29ada932-8ce4-4910-89e7-b7c42249afb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-3686-7148-b8ac-67299009214d.webp",
      "image_media": {
        "alt_text": "Exterior view of Polo Run apartment building entrance with landscaping and signage.",
        "public_id": "019fa4a2-3686-7148-b8ac-67299009214d",
        "storage_key": "property/6767906449165619/019fa4a2-3686-7148-b8ac-67299009214d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Polo Run, an apartment community offering modern living with beautiful landscaping and a convenient location. Explore our grounds and find your perfect home.",
      "link": "",
      "alt_text": "Exterior view of Polo Run apartment building entrance with landscaping and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94f9c5d2-40c7-4ba2-a24c-efe737dc9fea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-44a9-72a3-b2ac-e25c15c2e391.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with balconies and brick accents.",
        "public_id": "019fa4a2-44a9-72a3-b2ac-e25c15c2e391",
        "storage_key": "property/6767906449165619/019fa4a2-44a9-72a3-b2ac-e25c15c2e391.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the apartment buildings' exterior, showcasing balconies, brickwork, and communal outdoor spaces.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with balconies and brick accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8612ab0b-3f7e-4267-be10-005566f7c51b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a6-40ed-7424-9ab9-430a332c0489.webp",
      "image_media": {
        "alt_text": "Island kitchen with four bar stools in front of it.",
        "public_id": "019fa4a6-40ed-7424-9ab9-430a332c0489",
        "storage_key": "property/6767906449165619/019fa4a6-40ed-7424-9ab9-430a332c0489.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "A spacious island kitchen featuring bar stools, a refrigerator, coffee maker, and ample counter space.",
      "link": "",
      "alt_text": "Island kitchen with four bar stools in front of it.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_385608d2-c93d-49b8-afa5-b33a0825b83f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a6-40ec-73d5-8443-0237ee41898b.webp",
      "image_media": {
        "alt_text": "Lounge area with two sofas facing a fireplace and TV.",
        "public_id": "019fa4a6-40ec-73d5-8443-0237ee41898b",
        "storage_key": "property/6767906449165619/019fa4a6-40ec-73d5-8443-0237ee41898b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lounge, featuring comfortable seating and a cozy fireplace.",
      "link": "",
      "alt_text": "Lounge area with two sofas facing a fireplace and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_91dd7e35-2a31-4356-9550-8c0be4c77cad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a6-3e6d-705d-8983-4a75ff647464.webp",
      "image_media": {
        "alt_text": "Spacious community lounge area with vaulted ceilings, exposed beams, a fireplace, and a modern kitchen island.",
        "public_id": "019fa4a6-3e6d-705d-8983-4a75ff647464",
        "storage_key": "property/6767906449165619/019fa4a6-3e6d-705d-8983-4a75ff647464.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community lounge, featuring a cozy fireplace, ample seating, and a stylish kitchen island perfect for entertaining.",
      "link": "",
      "alt_text": "Spacious community lounge area with vaulted ceilings, exposed beams, a fireplace, and a modern kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_652234c5-185d-40e0-9d77-718a8ab0277f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a6-3d54-71ab-8a95-abb4242c58d3.webp",
      "image_media": {
        "alt_text": "Lounge area with two plush sofas facing each other, a coffee table, and a bar with stools in the background.",
        "public_id": "019fa4a6-3d54-71ab-8a95-abb4242c58d3",
        "storage_key": "property/6767906449165619/019fa4a6-3d54-71ab-8a95-abb4242c58d3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in the spacious lounge area, featuring comfortable seating and a modern bar, perfect for socializing or unwinding.",
      "link": "",
      "alt_text": "Lounge area with two plush sofas facing each other, a coffee table, and a bar with stools in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a53aaae1-d558-41d3-a96b-3bd750be9ace",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-4ba1-738b-a847-bd7c17fd2dce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4ba1-738b-a847-bd7c17fd2dce",
        "storage_key": "property/6767906449165619/019d2709-4ba1-738b-a847-bd7c17fd2dce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7f8a-7029-a775-41546ac647c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7f8a-7029-a775-41546ac647c1",
        "storage_key": "property/6767906449165619/019d2709-7f8a-7029-a775-41546ac647c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_2e6ff755-4b5a-4af6-8b10-01e4c36b5f97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-4be2-76bb-af2d-1f86a3e489df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4be2-76bb-af2d-1f86a3e489df",
        "storage_key": "property/6767906449165619/019d2709-4be2-76bb-af2d-1f86a3e489df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7f8a-7029-a775-41546ac647c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7f8a-7029-a775-41546ac647c1",
        "storage_key": "property/6767906449165619/019d2709-7f8a-7029-a775-41546ac647c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_72e51490-eb57-4a85-9168-197de0adaa10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-4b54-7411-ae2e-1d4c50711f6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4b54-7411-ae2e-1d4c50711f6c",
        "storage_key": "property/6767906449165619/019d2709-4b54-7411-ae2e-1d4c50711f6c.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7f8a-7029-a775-41546ac647c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7f8a-7029-a775-41546ac647c1",
        "storage_key": "property/6767906449165619/019d2709-7f8a-7029-a775-41546ac647c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_0b1787b5-1aad-464f-a758-bbcce3505b59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Popular fast-food chain specializing in chicken sandwiches and nuggets.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-4b46-746f-80ea-d800ac67fda6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4b46-746f-80ea-d800ac67fda6",
        "storage_key": "property/6767906449165619/019d2709-4b46-746f-80ea-d800ac67fda6.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7f8a-7029-a775-41546ac647c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7f8a-7029-a775-41546ac647c1",
        "storage_key": "property/6767906449165619/019d2709-7f8a-7029-a775-41546ac647c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_9afb97b4-ba02-496d-9044-0fc9155970cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-500f-73d7-9744-2bcc76a7f518.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-500f-73d7-9744-2bcc76a7f518",
        "storage_key": "property/6767906449165619/019d2709-500f-73d7-9744-2bcc76a7f518.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7f22-739a-bad2-eb889dbcaf35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7f22-739a-bad2-eb889dbcaf35",
        "storage_key": "property/6767906449165619/019d2709-7f22-739a-bad2-eb889dbcaf35.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_644cf517-d2eb-4954-b28c-88ac13a5228b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and discounts. They highlight the clean, spacious, and welcoming atmosphere, as well as the convenient layout and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-5069-7734-bdc2-a24afdb57e30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5069-7734-bdc2-a24afdb57e30",
        "storage_key": "property/6767906449165619/019d2709-5069-7734-bdc2-a24afdb57e30.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7f22-739a-bad2-eb889dbcaf35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7f22-739a-bad2-eb889dbcaf35",
        "storage_key": "property/6767906449165619/019d2709-7f22-739a-bad2-eb889dbcaf35.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_beaf8428-4fe9-4119-8075-b2908bee54a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "3702 S Peoria Ave, Tulsa, OK 74105, USA",
      "poi_short_description": "Spacious store and chain supermarket known for its affordable prices and wide variety of foods from around the world, including organic and vegan options.",
      "poi_long_description": "People say this grocery store offers a wide variety of unique items, fresh flowers, and delicious snacks. They highlight the great value, affordable prices, and clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-505e-774f-bb06-a3f16aa96929.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-505e-774f-bb06-a3f16aa96929",
        "storage_key": "property/6767906449165619/019d2709-505e-774f-bb06-a3f16aa96929.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/tulsa/460/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13583892652892204013&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "36.1096067",
      "poi_longitude": "-95.975934",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-712-9768",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7edf-74e5-90fb-1715c6433e52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7edf-74e5-90fb-1715c6433e52",
        "storage_key": "property/6767906449165619/019d2709-7edf-74e5-90fb-1715c6433e52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TxY2lOTtocR7autsmWug7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3fc591cc-7396-465b-8c56-690403a6f864",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-510a-75b9-9992-4ec6bd52af9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-510a-75b9-9992-4ec6bd52af9b",
        "storage_key": "property/6767906449165619/019d2709-510a-75b9-9992-4ec6bd52af9b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7edf-74e5-90fb-1715c6433e52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7edf-74e5-90fb-1715c6433e52",
        "storage_key": "property/6767906449165619/019d2709-7edf-74e5-90fb-1715c6433e52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ae7cd773-9078-4991-a305-226bcc927745",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Tulsa Hills Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7380 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Outdoor mall featuring Big Box stores alongside multiple restaurants and a movie theater.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and convenient stores. They highlight the convenient parking, easy access, and clean facilities. They also like the variety of businesses, including an emergency hospital and EV charging stations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-550c-701b-a3c0-b6db8358d0e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-550c-701b-a3c0-b6db8358d0e4",
        "storage_key": "property/6767906449165619/019d2709-550c-701b-a3c0-b6db8358d0e4.webp",
        "width": 1280,
        "height": 1027
      },
      "poi_business_url": "http://www.shoptulsahills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185409236621719808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-hills-shopping-center",
      "poi_latitude": "36.0563227",
      "poi_longitude": "-96.0033215",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-979-3334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7f22-739a-bad2-eb889dbcaf35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7f22-739a-bad2-eb889dbcaf35",
        "storage_key": "property/6767906449165619/019d2709-7f22-739a-bad2-eb889dbcaf35.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5R7A_GeUtocRAPl5hIaPFTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_df9f7bde-2f77-4215-8b34-9b22888f618b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-54c0-776a-8961-80a289d72000.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-54c0-776a-8961-80a289d72000",
        "storage_key": "property/6767906449165619/019d2709-54c0-776a-8961-80a289d72000.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7f6c-740e-8747-079de189ea01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7f6c-740e-8747-079de189ea01",
        "storage_key": "property/6767906449165619/019d2709-7f6c-740e-8747-079de189ea01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_540927cf-f4c0-4ec0-8d6b-b20e85eb8d70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-55b3-762f-89e9-545aeffa2774.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-55b3-762f-89e9-545aeffa2774",
        "storage_key": "property/6767906449165619/019d2709-55b3-762f-89e9-545aeffa2774.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7f6c-740e-8747-079de189ea01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7f6c-740e-8747-079de189ea01",
        "storage_key": "property/6767906449165619/019d2709-7f6c-740e-8747-079de189ea01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_11800139-3281-4c52-8613-511999ad5df1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-55a4-70a6-95f7-884b1c5d53d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-55a4-70a6-95f7-884b1c5d53d3",
        "storage_key": "property/6767906449165619/019d2709-55a4-70a6-95f7-884b1c5d53d3.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7f6c-740e-8747-079de189ea01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7f6c-740e-8747-079de189ea01",
        "storage_key": "property/6767906449165619/019d2709-7f6c-740e-8747-079de189ea01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_237f4672-a4ac-47af-b5ac-37a55f06e4b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-59d6-70ac-b8e0-d6f7a2404683.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-59d6-70ac-b8e0-d6f7a2404683",
        "storage_key": "property/6767906449165619/019d2709-59d6-70ac-b8e0-d6f7a2404683.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7f6c-740e-8747-079de189ea01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7f6c-740e-8747-079de189ea01",
        "storage_key": "property/6767906449165619/019d2709-7f6c-740e-8747-079de189ea01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_35edbba2-e2f6-4373-9de3-75d093e37f85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Relaxed aquarium with sharks, river otters, turtles and jellyfish.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-5a37-75df-810e-d3fd6f82afb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5a37-75df-810e-d3fd6f82afb6",
        "storage_key": "property/6767906449165619/019d2709-5a37-75df-810e-d3fd6f82afb6.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_70c1516c-7f7f-40bd-a047-7e3fb880f26a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Philbrook Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2727 S Rockford Rd, Tulsa, OK 74114, USA",
      "poi_short_description": "Villa-style museum showcasing European, Native American and Asian art, plus rotating exhibits.",
      "poi_long_description": "People say this museum offers a diverse art collection, including a Samurai exhibit, and features a historic mansion with beautiful architecture and breathtaking gardens. They highlight the peaceful and tranquil atmosphere, and the well-maintained grounds perfect for walking and taking photos. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-5a7d-71ca-a576-9ace5e0dec5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5a7d-71ca-a576-9ace5e0dec5a",
        "storage_key": "property/6767906449165619/019d2709-5a7d-71ca-a576-9ace5e0dec5a.webp",
        "width": 1280,
        "height": 904
      },
      "poi_business_url": "http://www.philbrook.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301074669923315730&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "philbrook-museum-of-art",
      "poi_latitude": "36.1238549",
      "poi_longitude": "-95.9700944",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-749-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-836b-702f-b9bf-e31c4493d4b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-836b-702f-b9bf-e31c4493d4b4",
        "storage_key": "property/6767906449165619/019d2709-836b-702f-b9bf-e31c4493d4b4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VsvX7DstocRErAJ14RYDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ea46ad02-50f2-4e21-9854-ca6b03572a33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Discovery Lab",
      "poi_type": "Entertainment",
      "poi_address": "3123 Riverside Dr, Tulsa, OK 74105, USA",
      "poi_short_description": "Relaxed spot with a playground and exhibits for kids on science, technology and art.",
      "poi_long_description": "People say this children's museum offers a wide variety of interactive and educational exhibits, including a ball area, climbing structures, and water play. They highlight the fun, hands-on learning experience, and the value of a membership for frequent visits. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-5b11-757a-8995-268d80c84aaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5b11-757a-8995-268d80c84aaf",
        "storage_key": "property/6767906449165619/019d2709-5b11-757a-8995-268d80c84aaf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverylab.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13384989011052284106&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "discovery-lab",
      "poi_latitude": "36.1180586",
      "poi_longitude": "-95.9841454",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-295-8144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-836b-702f-b9bf-e31c4493d4b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-836b-702f-b9bf-e31c4493d4b4",
        "storage_key": "property/6767906449165619/019d2709-836b-702f-b9bf-e31c4493d4b4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJi01Lj3vrtocRykhHvpYIwbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_25d04f95-2b02-4536-850c-5aa2f44b3adb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-5f2e-7740-882f-a898b8678a9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5f2e-7740-882f-a898b8678a9b",
        "storage_key": "property/6767906449165619/019d2709-5f2e-7740-882f-a898b8678a9b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_e3670691-9b7b-4f29-8909-1f2749a2395a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-678a-7559-b47a-c9722911701c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-678a-7559-b47a-c9722911701c",
        "storage_key": "property/6767906449165619/019d2709-678a-7559-b47a-c9722911701c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_62bb2fcd-c9df-438b-8001-8d266f7451fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-5fc2-71fe-ba15-0931fd295ea0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5fc2-71fe-ba15-0931fd295ea0",
        "storage_key": "property/6767906449165619/019d2709-5fc2-71fe-ba15-0931fd295ea0.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2733405a-e87b-4270-9e84-83239f9816fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-60d3-7379-9047-5db871ad1eae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-60d3-7379-9047-5db871ad1eae",
        "storage_key": "property/6767906449165619/019d2709-60d3-7379-9047-5db871ad1eae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_da5a8a17-5de5-4ce6-8f4d-1253991a3927",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Oklahoma Veterinary Specialists",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 West 78th Street South, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-63eb-71bf-a812-c85e17fb4dd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-63eb-71bf-a812-c85e17fb4dd3",
        "storage_key": "property/6767906449165619/019d2709-63eb-71bf-a812-c85e17fb4dd3.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://okvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5093478136724344104&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-veterinary-specialists",
      "poi_latitude": "36.0519175",
      "poi_longitude": "-96.0079484",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-299-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8o0AyeUtocRKE2sAmGrr0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_62743443-b39f-4733-91fd-e5a4df6a7c23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "Gym goers say this gym offers a clean and tidy facility with a welcoming and judgement-free atmosphere, and they appreciate the friendly and helpful staff. They also highlight the great price and smooth interaction with other members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-6474-769c-afc2-87f544da0277.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6474-769c-afc2-87f544da0277",
        "storage_key": "property/6767906449165619/019d2709-6474-769c-afc2-87f544da0277.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_30695980-16bf-4279-8a97-c935968c3c0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "iidentity salon",
      "poi_type": "Health and Wellness",
      "poi_address": "2731 S Harvard Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Hair styling salon with a friendly staff and a warm atmosphere, offering cuts and coloring services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-6534-749e-be56-df9d41138f71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6534-749e-be56-df9d41138f71",
        "storage_key": "property/6767906449165619/019d2709-6534-749e-be56-df9d41138f71.webp",
        "width": 960,
        "height": 893
      },
      "poi_business_url": "http://www.iidentitysalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9820300745508314431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iidentity-salon",
      "poi_latitude": "36.1232992",
      "poi_longitude": "-95.9400579",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-747-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8vHnFGTtocRP92Gc3-3SIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_e867b6f7-895d-4fba-bea6-f192a1db419b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "4915 E 41st St Suite A, Tulsa, OK 74135, USA",
      "poi_short_description": "Beauty retailer carrying a wide selection of products and offering salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-6810-718f-8b68-1d98b2e3c4c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6810-718f-8b68-1d98b2e3c4c2",
        "storage_key": "property/6767906449165619/019d2709-6810-718f-8b68-1d98b2e3c4c2.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-131",
      "poi_directions_map_url": "https://maps.google.com/?cid=10581466912609131404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.1058946",
      "poi_longitude": "-95.9208289",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-664-5916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeUzsceStocRjNudEBjs2JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_761ffdd4-71d0-4071-aee8-6dc17493203a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "4818 E 80th St Ste A, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, fitness classes, and amenities, including tanning, massage beds, and a sauna. They highlight the clean facilities, friendly staff, and welcoming atmosphere, with people from all walks of life enjoying their workouts. They also like the affordable prices and convenient 24-hour access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-692b-7653-b31b-6398ce76813f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-692b-7653-b31b-6398ce76813f",
        "storage_key": "property/6767906449165619/019d2709-692b-7653-b31b-6398ce76813f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://10gym.com/south-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406416433432823692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.047648",
      "poi_longitude": "-95.9239656",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-494-3644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-ITWKKTtocRjAdtGP9OZSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c63f9020-9d71-46fb-9032-9c1ed045bdfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-6a00-7636-9633-f7b0f46927ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6a00-7636-9633-f7b0f46927ea",
        "storage_key": "property/6767906449165619/019d2709-6a00-7636-9633-f7b0f46927ea.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-83b5-750e-8e18-6a41a010106c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-83b5-750e-8e18-6a41a010106c",
        "storage_key": "property/6767906449165619/019d2709-83b5-750e-8e18-6a41a010106c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_eea0cef9-595b-4c9a-ab34-17ae32cc4bd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Ascension St. John Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1923 S Utica Ave, Tulsa, OK 74104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-6c78-7358-a0d1-65921460041a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6c78-7358-a0d1-65921460041a",
        "storage_key": "property/6767906449165619/019d2709-6c78-7358-a0d1-65921460041a.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/oklahoma/oktul/tulsa-ascension-st-john-medical-center?utm_campaign=gmb&utm_medium=organic&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16615004765601411578&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-st-john-medical-center",
      "poi_latitude": "36.1341017",
      "poi_longitude": "-95.9666058",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-744-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-83b5-750e-8e18-6a41a010106c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-83b5-750e-8e18-6a41a010106c",
        "storage_key": "property/6767906449165619/019d2709-83b5-750e-8e18-6a41a010106c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0zInA23ttocR-jEY481alOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b4be73bc-0e89-4f4c-9008-b43b9c8d0581",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Gathering Place",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2650 S John Williams Way, Tulsa, OK 74114, USA",
      "poi_short_description": "Large, family-friendly park featuring playgrounds, splash pads, walking trails and gardens.",
      "poi_long_description": "People say this park offers a variety of playgrounds, walking trails, and water activities, including kayaking and paddle boating. They highlight the free admission, family-friendly atmosphere, and peaceful vibe. They also like the clean restrooms and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-6d25-76ce-836f-117c9ce19eac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6d25-76ce-836f-117c9ce19eac",
        "storage_key": "property/6767906449165619/019d2709-6d25-76ce-836f-117c9ce19eac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatheringplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14222367875341211287&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gathering-place",
      "poi_latitude": "36.1251603",
      "poi_longitude": "-95.9840207",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-779-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-8435-760e-8142-fa1cdd9c92a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8435-760e-8142-fa1cdd9c92a9",
        "storage_key": "property/6767906449165619/019d2709-8435-760e-8142-fa1cdd9c92a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYnn1dDttocRl9ajsjoAYMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_730b6048-9751-4bd3-9898-32ad89c80614",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Woodward Park and Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2435 S Peoria Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Parklike setting with a 1919 Italian Renaissance-style home and a rose garden, plus playgrounds and walking paths.",
      "poi_long_description": "People say this park offers beautiful gardens, flowers, and roses, and is a popular wedding venue. They highlight the peaceful and relaxing atmosphere, and the abundance of wildlife, including squirrels and bunnies. They also like the well-maintained grounds, picnic areas, and walking paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-6dfe-744f-9642-d05b3e9ff64c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6dfe-744f-9642-d05b3e9ff64c",
        "storage_key": "property/6767906449165619/019d2709-6dfe-744f-9642-d05b3e9ff64c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.tulsagardencenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12962617171359971077&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodward-park-and-gardens",
      "poi_latitude": "36.1319247",
      "poi_longitude": "-95.9736606",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-576-5155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-8435-760e-8142-fa1cdd9c92a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8435-760e-8142-fa1cdd9c92a9",
        "storage_key": "property/6767906449165619/019d2709-8435-760e-8142-fa1cdd9c92a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr8FnRKPstocRBTdKcqN35LM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9ba6bf31-7240-49f3-ae61-937de98739cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-6ee2-729d-86f6-270deb1a94ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6ee2-729d-86f6-270deb1a94ea",
        "storage_key": "property/6767906449165619/019d2709-6ee2-729d-86f6-270deb1a94ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-8435-760e-8142-fa1cdd9c92a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8435-760e-8142-fa1cdd9c92a9",
        "storage_key": "property/6767906449165619/019d2709-8435-760e-8142-fa1cdd9c92a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_26d2f681-89cb-4511-a39e-02d513a11789",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-71d6-748e-bb5e-ed5f66a093bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-71d6-748e-bb5e-ed5f66a093bd",
        "storage_key": "property/6767906449165619/019d2709-71d6-748e-bb5e-ed5f66a093bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-8435-760e-8142-fa1cdd9c92a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8435-760e-8142-fa1cdd9c92a9",
        "storage_key": "property/6767906449165619/019d2709-8435-760e-8142-fa1cdd9c92a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3b7cd64a-a7fb-456c-8481-7977d4279a18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-72ff-74bd-b344-5cf08dab4fc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-72ff-74bd-b344-5cf08dab4fc6",
        "storage_key": "property/6767906449165619/019d2709-72ff-74bd-b344-5cf08dab4fc6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-8435-760e-8142-fa1cdd9c92a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8435-760e-8142-fa1cdd9c92a9",
        "storage_key": "property/6767906449165619/019d2709-8435-760e-8142-fa1cdd9c92a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b1e6789e-290f-4df3-9f27-97c8309ea6be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Tulsa Riverside Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8605 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-72f5-737e-bc0e-9c93eef4ca93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-72f5-737e-bc0e-9c93eef4ca93",
        "storage_key": "property/6767906449165619/019d2709-72f5-737e-bc0e-9c93eef4ca93.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://flytulsa.com/tulsa-river-side/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10887194896589047936&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-riverside-airport",
      "poi_latitude": "36.0378532",
      "poi_longitude": "-95.9909439",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-299-5886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-871c-71aa-821d-3da632abc2a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-871c-71aa-821d-3da632abc2a5",
        "storage_key": "property/6767906449165619/019d2709-871c-71aa-821d-3da632abc2a5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-5WQAiUtocRgMiiWxMWF5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_b201a257-30ae-4b04-a7cb-5a98077aa417",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Christiansen Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "8767 S Jack Bates Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7386-76c9-9a2b-a2eac5fd6dee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7386-76c9-9a2b-a2eac5fd6dee",
        "storage_key": "property/6767906449165619/019d2709-7386-76c9-9a2b-a2eac5fd6dee.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://christiansenaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204997232924193680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christiansen-aviation",
      "poi_latitude": "36.0365935",
      "poi_longitude": "-95.9895957",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-299-2646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-871c-71aa-821d-3da632abc2a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-871c-71aa-821d-3da632abc2a5",
        "storage_key": "property/6767906449165619/019d2709-871c-71aa-821d-3da632abc2a5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SWkpQWUtocRkHOu4Z0lgJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_899bd458-0723-4b0f-a6fe-bc25edc7f43a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7784-76cc-842f-c2d6955cba51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7784-76cc-842f-c2d6955cba51",
        "storage_key": "property/6767906449165619/019d2709-7784-76cc-842f-c2d6955cba51.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_93b157ca-5a3e-4e72-84f5-1851c49b46de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7732-7163-89a8-e9ff26d70b66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7732-7163-89a8-e9ff26d70b66",
        "storage_key": "property/6767906449165619/019d2709-7732-7163-89a8-e9ff26d70b66.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0b52e0d6-2375-42fb-afa6-052496b9e7e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7917-73fa-b988-ab0cb7876fef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7917-73fa-b988-ab0cb7876fef",
        "storage_key": "property/6767906449165619/019d2709-7917-73fa-b988-ab0cb7876fef.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_aec46d0f-aab2-47c0-87f5-600e503a26f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c3201cc1-33a9-44ee-bd98-d166eb5b9e28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Pepsi Main Truck Gate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5201-5325 S Lawton Ave, Tulsa, OK 74107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-7850-754e-990d-113cc12570e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7850-754e-990d-113cc12570e2",
        "storage_key": "property/6767906449165619/019d2709-7850-754e-990d-113cc12570e2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4654779687138613676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pepsi-main-truck-gate",
      "poi_latitude": "36.0874451",
      "poi_longitude": "-95.9993929",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-82c8-705a-a2f7-8f9f22c4230f",
        "storage_key": "property/6767906449165619/019d2709-82c8-705a-a2f7-8f9f22c4230f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQbkIZSUtocRrNmZn3YZmUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3c1fd7ae-8771-4206-83ef-402421e45525",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Key Elementary School",
      "poi_type": "Education",
      "poi_address": "5702 S Irvington Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://key.tulsaschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11853114340522366647&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "key-elementary-school",
      "poi_latitude": "36.0810966",
      "poi_longitude": "-95.9115447",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8ead-7778-89c5-ea4eeb676b42",
        "storage_key": "property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfRjnFo-StocRt5bsNLG4fqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5084e467-6b09-4455-90ea-4e5f2eaca0fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Memorial High School",
      "poi_type": "Education",
      "poi_address": "5840 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-c7f9-700a-9d0b-1509aae4e955.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c7f9-700a-9d0b-1509aae4e955",
        "storage_key": "property/6767906449165619/019d7912-c7f9-700a-9d0b-1509aae4e955.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://memorial.tulsaschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13857617040675689831&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "memorial-high-school",
      "poi_latitude": "36.0789084",
      "poi_longitude": "-95.9145622",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-833-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8ead-7778-89c5-ea4eeb676b42",
        "storage_key": "property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY_WXTomStocRZ9XfFkclUMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a9a8d3f7-8d6f-4979-a706-6bb0b4c653ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Tulsa Public Schools HR",
      "poi_type": "Education",
      "poi_address": "3027 S New Haven Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tulsaschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11062137004618846795&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-public-schools-hr",
      "poi_latitude": "36.11945499999999",
      "poi_longitude": "-95.93280500000002",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-746-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8ead-7778-89c5-ea4eeb676b42",
        "storage_key": "property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrW2Nqy3ttocRS5IC-f6ahJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_583c923e-022b-4aaa-9c66-2cdaae454bab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Byrd Junior High School",
      "poi_type": "Education",
      "poi_address": "Tulsa, OK 74145, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1718518887176664939&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "byrd-junior-high-school",
      "poi_latitude": "36.0819456",
      "poi_longitude": "-95.8926846",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8ead-7778-89c5-ea4eeb676b42",
        "storage_key": "property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo0s89XuNtocRa_f2odJn2Rc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2242072d-77b2-4fa6-ac56-2b20d799af37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Spartan Collage Of Aeronautics and Technology - FLIGHT CAMPUS",
      "poi_type": "Education",
      "poi_address": "Tulsa, OK 74132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-c8cc-763e-bb2d-be0591b3bfa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c8cc-763e-bb2d-be0591b3bfa5",
        "storage_key": "property/6767906449165619/019d7912-c8cc-763e-bb2d-be0591b3bfa5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12725979814749809731&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spartan-collage-of-aeronautics-and-technology-flight-campus",
      "poi_latitude": "36.0370357",
      "poi_longitude": "-95.989939",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8ead-7778-89c5-ea4eeb676b42",
        "storage_key": "property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv1O8kgWUtocRQyz0ZDfDm7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0e8fc450-f1a9-4eef-a927-7acbfd283a20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-c666-74af-8dc6-bbef35f0b3b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c666-74af-8dc6-bbef35f0b3b6",
        "storage_key": "property/6767906449165619/019d7912-c666-74af-8dc6-bbef35f0b3b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8ead-7778-89c5-ea4eeb676b42",
        "storage_key": "property/6767906449165619/019cfb45-8ead-7778-89c5-ea4eeb676b42.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7e55d09d-9a74-4b33-9eec-3ffc37f4fbc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Mahogany Prime Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "4840 E 61st St, Tulsa, OK 74136, USA",
      "poi_short_description": "Sophisticated restaurant offering steaks, seafood & creative cocktails in refined surroundings.",
      "poi_long_description": "People say this steakhouse serves perfectly cooked, flavorful steaks, and delicious lobster mac and cheese. They highlight the excellent service, attentive staff, and upscale, elegant atmosphere, making it ideal for special occasions. They also like the generous portions and good value.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-c804-723d-b4b3-05b9e1c9105c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c804-723d-b4b3-05b9e1c9105c",
        "storage_key": "property/6767906449165619/019d7912-c804-723d-b4b3-05b9e1c9105c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://mahoganyprimesteakhouse.com/locations/mahogany-tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13122200333241441640&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mahogany-prime-steakhouse",
      "poi_latitude": "36.0744916",
      "poi_longitude": "-95.9237582",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-494-4043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e98-772a-8e29-9d20bcb34453",
        "storage_key": "property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Q_uOV2StocRaF1evq1rG7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_69f0d4b4-6e88-4415-9254-3071b145c2b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Ruth's Chris Steak House",
      "poi_type": "Restaurants",
      "poi_address": "8330 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Outpost of upmarket steakhouse chain known for sizzling, butter-topped beef in an elegant setting",
      "poi_long_description": "People say this steakhouse serves delicious, flavorful dishes, including perfectly cooked steaks and flavorful sides. They highlight the romantic and fun atmosphere, and the attentive service. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-d6cc-7246-b748-8e801cc1217f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d6cc-7246-b748-8e801cc1217f",
        "storage_key": "property/6767906449165619/019d7912-d6cc-7246-b748-8e801cc1217f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ruthschris.com/locations/ok/tulsa/tulsa/7389?cmpid=br:rc_ag:ie_ch:loc_ca:RCGMB_sn:gmb_gt:tulsa-ok-7389_pl:locurl_rd:1061",
      "poi_directions_map_url": "https://maps.google.com/?cid=14258754823309275141&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ruth-s-chris-steak-house",
      "poi_latitude": "36.0412396",
      "poi_longitude": "-95.9626687",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-995-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e98-772a-8e29-9d20bcb34453",
        "storage_key": "property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXUTGLeiTtocRBbC8NvdF4cU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_5ea94fe0-2feb-4299-b713-ad8172e643a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "McNellie's South City",
      "poi_type": "Restaurants",
      "poi_address": "7031 S Zurich Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this bar and grill serves great pub food, including burgers, fish and chips, and gyros. They also highlight the extensive beer selection, the classic pub atmosphere, and the friendly and attentive service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-da10-7566-8183-edee3e4346fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-da10-7566-8183-edee3e4346fa",
        "storage_key": "property/6767906449165619/019d7912-da10-7566-8183-edee3e4346fa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mcnellies.com/locations/south-tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6111737585518355192&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mcnellie-s-south-city",
      "poi_latitude": "36.0620675",
      "poi_longitude": "-95.920491",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-933-5250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7913-157b-755d-b721-fd34c0fbaa6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-157b-755d-b721-fd34c0fbaa6e",
        "storage_key": "property/6767906449165619/019d7913-157b-755d-b721-fd34c0fbaa6e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFaGPsEKStocR-KI54fNA0VQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_fe53623b-9acf-4744-a6a2-1977f0e5c607",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Charleston's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6839 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Relaxed hangout serving classic pub fare, such as burgers, ribs & tenders, plus wine & cocktails.",
      "poi_long_description": "People say this American restaurant serves delicious pork chops, catfish, and ribs. They highlight the generous portions, reasonable prices, and the tasty carrot cake. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-d851-7759-9226-8fac60660233.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d851-7759-9226-8fac60660233",
        "storage_key": "property/6767906449165619/019d7912-d851-7759-9226-8fac60660233.webp",
        "width": 1280,
        "height": 737
      },
      "poi_business_url": "http://charlestons.com/locations/charlestons-tulsa-yale/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7497404920118451132&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charleston-s-restaurant",
      "poi_latitude": "36.0629988",
      "poi_longitude": "-95.9215204",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-495-3511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e98-772a-8e29-9d20bcb34453",
        "storage_key": "property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHXuQNF2StocRvBvtSA0iDGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c279e99c-ab50-43f0-b7e4-0be5f1aeb719",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Bravos Méxican Grill",
      "poi_type": "Restaurants",
      "poi_address": "6104 E 71st St #26, Tulsa, OK 74136, USA",
      "poi_short_description": "Casual restaurant serving traditional Mexican dishes such as fajitas and margaritas.",
      "poi_long_description": "People say this Mexican restaurant serves delicious pork street tacos, chicken fajitas, and chimichangas. They also highlight the friendly service, reasonable prices, and generous portions.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-d51b-7199-9871-4fe9e09f0457.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d51b-7199-9871-4fe9e09f0457",
        "storage_key": "property/6767906449165619/019d7912-d51b-7199-9871-4fe9e09f0457.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://71street.orderbravosmexicangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14866557595188203414&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bravos-m-xican-grill",
      "poi_latitude": "36.0604264",
      "poi_longitude": "-95.9076726",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-576-7003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e98-772a-8e29-9d20bcb34453",
        "storage_key": "property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJedGQvO6StocRlg8Uzl2fUM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_54af77bd-9891-49d4-9bd9-c28eafcc6dc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Smitty's Garage Burgers & Beer",
      "poi_type": "Restaurants",
      "poi_address": "7104 S Sheridan Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Hamburgers and beers in a spot equipped with flat-screens, plus a playground.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, fries, and tacos, with options for bison patties and gluten-free burgers. They highlight the good food, great management, and friendly staff, and like the fun, sports bar atmosphere with a bar and TVs. They also mention the service is attentive and accommodating, especially for large groups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-dffa-70ff-8f69-933f4002d8f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-dffa-70ff-8f69-933f4002d8f4",
        "storage_key": "property/6767906449165619/019d7912-dffa-70ff-8f69-933f4002d8f4.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://eatatthegarage.com/locations/smittys-garage-tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4203020793115402855&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smitty-s-garage-burgers-beer",
      "poi_latitude": "36.0604407",
      "poi_longitude": "-95.9062243",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-584-8484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e98-772a-8e29-9d20bcb34453",
        "storage_key": "property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGWUuBXGStocRZ2I5jSQhVDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_a3cde079-2d95-4dc2-ba2d-41c0fadfc8f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Taziki's Mediterranean Cafe - 71st and Yale",
      "poi_type": "Restaurants",
      "poi_address": "4929 E 71st St, Tulsa, OK 74136, USA",
      "poi_short_description": "Comfy chain eatery providing made-to-order gyros & other Mediterranean dishes plus beer & wine.",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious gyros, falafel, and baklava. They also highlight the clean dining room, friendly staff, and reasonable prices.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-e7bb-76d8-ae6b-78f5207b1d83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e7bb-76d8-ae6b-78f5207b1d83",
        "storage_key": "property/6767906449165619/019d7912-e7bb-76d8-ae6b-78f5207b1d83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tazikis.com/location/71st-and-yale/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3730727031994476618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "taziki-s-mediterranean-cafe-71st-and-yale",
      "poi_latitude": "36.061237",
      "poi_longitude": "-95.92061",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-986-8291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e98-772a-8e29-9d20bcb34453",
        "storage_key": "property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi-kfl0KStocRSmj6J3g0xjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_2cd52831-4a0e-4a4b-916f-fe776859df68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "New York Bagel Cafe",
      "poi_type": "Restaurants",
      "poi_address": "6805 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Comfortable eatery, featuring a variety of bagels and sandwiches as well as cookies and muffins.",
      "poi_long_description": "People say this bakery offers delicious bagels, with a variety of options including plain, everything, and lox. They highlight the fresh, soft, and chewy texture of the bagels, and the generous portions of cream cheese. They also like the friendly and helpful staff, and the quick and easy ordering process.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-e980-713a-bd78-9ce4344ed155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e980-713a-bd78-9ce4344ed155",
        "storage_key": "property/6767906449165619/019d7912-e980-713a-bd78-9ce4344ed155.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://newyorkbageltulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11398810098547252305&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "new-york-bagel-cafe",
      "poi_latitude": "36.0639766",
      "poi_longitude": "-95.9214383",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-340-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e98-772a-8e29-9d20bcb34453",
        "storage_key": "property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9OaPl2StocRUVwLImS1MJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_3f79c197-eb22-4dae-ad2b-7957c1f2fd8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Sonic Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "8030 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_long_description": "Some diners say this fast food restaurant offers decent food.\n\nOther reviews mention the service can be slow and customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-e96b-7156-b665-df6b022e3819.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e96b-7156-b665-df6b022e3819",
        "storage_key": "property/6767906449165619/019d7912-e96b-7156-b665-df6b022e3819.webp",
        "width": 1280,
        "height": 560
      },
      "poi_business_url": "http://www.sonicdrivein.com/locations/us/ok/tulsa/8030-s--lewis/store-3055?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAzMzg0ODQzMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5047357944934098230&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sonic-drive-in",
      "poi_latitude": "36.0467721",
      "poi_longitude": "-95.9583518",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-492-3396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e98-772a-8e29-9d20bcb34453",
        "storage_key": "property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_yutJMGTtocRNuUKEk_RC0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_8448434c-b102-4472-bc57-4bbf5558f13c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "Utica Square Shopping Ctr, 1714 Utica Square, Tulsa, OK 74114, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-f539-719c-8ccd-3066144acc27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f539-719c-8ccd-3066144acc27",
        "storage_key": "property/6767906449165619/019d7912-f539-719c-8ccd-3066144acc27.webp",
        "width": 611,
        "height": 456
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1714+utica+sq-tulsa-ok-74114/id=15782",
      "poi_directions_map_url": "https://maps.google.com/?cid=17942462309257141615&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.1328599",
      "poi_longitude": "-95.9660751",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-743-9968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8ea2-760c-9369-9ad9ceeccf64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8ea2-760c-9369-9ad9ceeccf64",
        "storage_key": "property/6767906449165619/019cfb45-8ea2-760c-9369-9ad9ceeccf64.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XYtKIDttocRb10bM2huAPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_4d0a829c-1959-4946-9dba-ed2fe7149e89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Lighthouse Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "Tulsa, OK 74136, USA",
      "poi_short_description": "Business center featuring a shopping mall, a UPS store, and the Hop the Griffin brewery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-f7fb-7669-81dc-790cea2bf27e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f7fb-7669-81dc-790cea2bf27e",
        "storage_key": "property/6767906449165619/019d7912-f7fb-7669-81dc-790cea2bf27e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8253140218136157186&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lighthouse-shopping-center",
      "poi_latitude": "36.0606053",
      "poi_longitude": "-95.9217878",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8ea2-760c-9369-9ad9ceeccf64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8ea2-760c-9369-9ad9ceeccf64",
        "storage_key": "property/6767906449165619/019cfb45-8ea2-760c-9369-9ad9ceeccf64.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJifPh9kKStocRAtx-J00LiXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_947b7b4c-0699-41b2-b2d9-bbb87fab57a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "4107 S Harvard Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-f81e-743d-a7fb-b09de39569f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f81e-743d-a7fb-b09de39569f3",
        "storage_key": "property/6767906449165619/019d7912-f81e-743d-a7fb-b09de39569f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/tulsa-ok-pharmacies/4107-s-harvard-ave-tulsa-ok-74135/storeid=7972?WT.mc_id=LS_GOOGLE_FS_7972",
      "poi_directions_map_url": "https://maps.google.com/?cid=6831089835541108407&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "36.1038119",
      "poi_longitude": "-95.939369",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-747-6690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8ea2-760c-9369-9ad9ceeccf64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8ea2-760c-9369-9ad9ceeccf64",
        "storage_key": "property/6767906449165619/019cfb45-8ea2-760c-9369-9ad9ceeccf64.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRVzXe_2StocRt5Y1RAPozF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_806482d0-9460-4ab7-9daf-7791b53eb899",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Reasor's",
      "poi_type": "Shopping & Retail",
      "poi_address": "7114 S Sheridan Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain grocer featuring prepared foods, a bakery, a floral department and a deli.",
      "poi_long_description": "People say this grocery store offers a wide variety of products, including fresh produce and meats. They also highlight the clean environment, helpful and friendly staff, and convenient self-checkout.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-fc4e-7119-b4ca-4a9c89f619be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fc4e-7119-b4ca-4a9c89f619be",
        "storage_key": "property/6767906449165619/019d7912-fc4e-7119-b4ca-4a9c89f619be.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.reasors.com/stores/sheridan",
      "poi_directions_map_url": "https://maps.google.com/?cid=8574870124423087901&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "reasor-s",
      "poi_latitude": "36.0597021",
      "poi_longitude": "-95.9059173",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-493-7442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e94-705b-bef4-e4b8062f5201.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e94-705b-bef4-e4b8062f5201",
        "storage_key": "property/6767906449165619/019cfb45-8e94-705b-bef4-e4b8062f5201.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOaEhMnGStocRHQdZUfIOAHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_49119162-9619-4a1c-ae28-96c6b0ad5943",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Southern Agriculture",
      "poi_type": "Shopping & Retail",
      "poi_address": "6501 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Retailer with supplies, food & medication for pets & farm animals, plus vaccination services.",
      "poi_long_description": "People say this pet supply store offers a wide variety of products for pets, including dogs, cats, birds, and fish, as well as outdoor farm and feed supplies. They also highlight the helpful and knowledgeable staff, and the large selection of cages, tanks, and toys.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7912-fe2c-76bd-91bd-9f6a9bd0bfc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fe2c-76bd-91bd-9f6a9bd0bfc2",
        "storage_key": "property/6767906449165619/019d7912-fe2c-76bd-91bd-9f6a9bd0bfc2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.southernagriculture.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8832453684486818411&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "southern-agriculture",
      "poi_latitude": "36.0619245",
      "poi_longitude": "-95.9031439",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-488-1993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e9b-7104-88cc-e9bc63d129dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e9b-7104-88cc-e9bc63d129dd",
        "storage_key": "property/6767906449165619/019cfb45-8e9b-7104-88cc-e9bc63d129dd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzy5RJ3eStocRa0rtZtQtk3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_72c13a59-2a55-449b-9349-f02cbe4452c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Utica Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "1709 Utica Square, Tulsa, OK 74114, USA",
      "poi_short_description": "Tree-lined outdoor shopping center open since 1952, featuring upscale chain brands & casual dining.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including popular retail brands, specialty shops, and a Saks Fifth Avenue, as well as numerous dining options. They highlight the beautiful, open-air layout, the convenient parking, and the relaxed and inviting atmosphere. They also like the well-maintained landscaping and seasonal decorations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7913-0071-761d-abbd-a810207e5fda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0071-761d-abbd-a810207e5fda",
        "storage_key": "property/6767906449165619/019d7913-0071-761d-abbd-a810207e5fda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uticasquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1952460493464208074&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "utica-square",
      "poi_latitude": "36.1321689",
      "poi_longitude": "-95.9628953",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-588-5209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e9b-7104-88cc-e9bc63d129dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e9b-7104-88cc-e9bc63d129dd",
        "storage_key": "property/6767906449165619/019cfb45-8e9b-7104-88cc-e9bc63d129dd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAVNNJr_stocRygLrZnmIGBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_7ea9370d-a650-4812-8dd2-7b3f92294f31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Guthrie Green",
      "poi_type": "Entertainment",
      "poi_address": "111 E Reconciliation Wy, Tulsa, OK 74103, USA",
      "poi_short_description": "Concerts, festivals, green markets, fitness classes, a sleek cafe & more in an urban park.",
      "poi_long_description": "People say this park offers a variety of events, including live music, movie nights, and festivals, and has plenty of seating, shade, and free wifi. They highlight the beautiful, clean, and well-maintained space, and the fun, relaxing, and family-friendly atmosphere. They also like the convenient access to food trucks and local restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7913-039b-7495-be88-a61797176e7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-039b-7495-be88-a61797176e7c",
        "storage_key": "property/6767906449165619/019d7913-039b-7495-be88-a61797176e7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.guthriegreen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9339549307871769339&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "guthrie-green",
      "poi_latitude": "36.1597162",
      "poi_longitude": "-95.9920028",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-574-2421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e9f-760a-9758-bbcd364adcf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e9f-760a-9758-bbcd364adcf1",
        "storage_key": "property/6767906449165619/019cfb45-8e9f-760a-9758-bbcd364adcf1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSYk4oLrtocR-zLxyZy-nIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_702c3e3f-d845-49ed-8168-d3f1eb5d05f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "MeadowBrook Country Club",
      "poi_type": "Entertainment",
      "poi_address": "9300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Members-only country club featuring golf, a pool, and dining options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7913-0694-74fd-9aec-ecd37dbdb97a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0694-74fd-9aec-ecd37dbdb97a",
        "storage_key": "property/6767906449165619/019d7913-0694-74fd-9aec-ecd37dbdb97a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.meadowbrookcc.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3095962914776590988&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "meadowbrook-country-club",
      "poi_latitude": "36.0454446",
      "poi_longitude": "-95.8728433",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-252-4121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8ea2-760c-9369-9ad9ceeccf64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8ea2-760c-9369-9ad9ceeccf64",
        "storage_key": "property/6767906449165619/019cfb45-8ea2-760c-9369-9ad9ceeccf64.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-bA0CMWNtocRjKoKLd4R9yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_6266bf6c-1341-416b-a5d5-ed7ea763f3ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Tulsa Zoo",
      "poi_type": "Entertainment",
      "poi_address": "6421 E 36th St N, Tulsa, OK 74115, USA",
      "poi_short_description": "An expansive, educational park with a huge variety of animals, plus the Safari Train & a carousel.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, sea lions, and tigers, and has a dinosaur exhibit, carousel, and playground. They highlight the membership is worth it, especially for large groups, and the zoo is family-friendly. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7913-057d-7609-9b93-468c0895d193.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-057d-7609-9b93-468c0895d193",
        "storage_key": "property/6767906449165619/019d7913-057d-7609-9b93-468c0895d193.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038979359347895889&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-zoo",
      "poi_latitude": "36.2130153",
      "poi_longitude": "-95.9064904",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 918-669-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8ea2-760c-9369-9ad9ceeccf64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8ea2-760c-9369-9ad9ceeccf64",
        "storage_key": "property/6767906449165619/019cfb45-8ea2-760c-9369-9ad9ceeccf64.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb_PwwXutocRUe5o3YmeUYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_77e42de8-5f5a-41d7-8321-af027b9afa0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Dave & Buster's Tulsa",
      "poi_type": "Entertainment",
      "poi_address": "6812 S 105th E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "People say this restaurant and entertainment venue offers delicious food, tasty drinks, and a wide variety of arcade games. They also highlight the friendly and helpful staff, and the fun and exciting atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019d7913-0c63-778e-96ac-47c4a12638a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0c63-778e-96ac-47c4a12638a3",
        "storage_key": "property/6767906449165619/019d7913-0c63-778e-96ac-47c4a12638a3.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12357992769235283287&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dave-buster-s-tulsa",
      "poi_latitude": "36.0651384",
      "poi_longitude": "-95.8605908",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-449-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-8e98-772a-8e29-9d20bcb34453",
        "storage_key": "property/6767906449165619/019cfb45-8e98-772a-8e29-9d20bcb34453.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_GbT6yNtocRV20du_JogKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2d73a9ae-3977-4604-b719-a3b10feb1a6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Johnny Rockets",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "johnny-rockets",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b83e401c-684b-4354-b07f-7f8eb9c71b4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Braum’s Ice Cream & Burger Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "braum-s-ice-cream-burger-restaurant",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_76cab10d-0398-44fa-9c94-17ae8b238326",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "poi_name": "Woodlands Hill Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "woodlands-hill-mall",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a3f1dcffbf31f2bdde6dd680",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a8456f040a53acd827171eb4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0ba514445e05c243dedc0eb0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_b4332565c1eec40e403a6915",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_a7f815c344390f4e2f394f38",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_8f19ffcd4e4439fd7857f9d3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_27c27a9b-732d-4bc0-9614-96c84356233a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "rating": "5.0",
      "name": "Rhianna Tso",
      "text": "Moved in recently and it’s been a great experience so far. The managers are super nice, helpful, and always communicate well. They made our first move-in smooth and answered all our questions. Maintenance has been quick and respectful. A few things still need fixing no complaints, but overall we’re happy here!",
      "date": "2025-06-25",
      "title": ""
    },
    {
      "id": "custom_955434f3-e8b7-491c-b113-358f1715429a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "rating": "5.0",
      "name": "Kimberly Hale",
      "text": "I've lived here 2 yrs & have had a great experience here. Maintenance was always fast within 1 to 2 days. In May I lost my job & haven't been able to pay rent but they have evicted me yet. I got a job & start on Monday July 21. I will be able to play on Aug 1. I fractured my foot on July 4 and uncle to walk on left foot, on crutches",
      "date": "2025-07-20",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_d373f79d-8c7f-4857-a1fb-87006ef366b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb46-0c65-75d7-8cc0-f3c4d1155eb8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the community clubhouse interior.",
        "public_id": "019cfb46-0c65-75d7-8cc0-f3c4d1155eb8",
        "storage_key": "property/6767906449165619/019cfb46-0c65-75d7-8cc0-f3c4d1155eb8.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Polo Run Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6304c2f48e10557cbe8364de"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-52d1-76f8-a245-4105d759767d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "polo-run-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619"
    },
    {
      "lead_collector_id": "019cf79e-5344-711d-bc6c-ec89d0204b92",
      "lead_source": "LANDING_PAGE",
      "name": "polo-run-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "dog-park-apartments-south-tulsa",
      "search_query": "dog park apartments in South Tulsa",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in South Tulsa",
      "h2_subtitle": "Discover pet-friendly living with a dog park amenity in South Tulsa. Polo Run Apartments offers a welcoming environment for you and your furry friends.",
      "page_copy": "At Polo Run Apartments in South Tulsa, we understand your pets are part of the family. Our community is tailored to pet owners who are in search of dog park apartments in South Tulsa. With spacious living spaces and amenities that cater to both humans and their furry companions, you’ll find the perfect balance of comfort and convenience.\n\nNestled in the serene area of South Tulsa, Polo Run provides the ideal backdrop for a vibrant lifestyle. Our apartment community includes a variety of amenities designed with both you and your pet in mind. Take advantage of the nearby walking trails or relax at the refreshing pool after an active day with your pet. Join us at Polo Run, where every resident, even the four-legged ones, feels at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in South Tulsa",
      "seo_description": "Find dog park apartments in South Tulsa at Polo Run. Enjoy pet-friendly living with great amenities and a welcoming atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "apartments-with-pool-tulsa-ok",
      "search_query": "apartments with pool in Tulsa OK",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Tulsa, OK",
      "h2_subtitle": "Discover the ideal lifestyle with apartments featuring a pool in Tulsa, OK. Polo Run Apartments offers a refreshing retreat right at home.",
      "page_copy": "If you're seeking apartments with a pool in Tulsa, OK, Polo Run Apartments is the perfect place to call home. Offering spacious one and two-bedroom layouts, our community is designed to meet the demands of modern living while providing luxurious amenities.\n\nLocated in vibrant South Tulsa, Polo Run Apartments boasts a refreshing pool that's perfect for cooling off on warm days or enjoying a leisurely dip. Along with the pool, our residents enjoy access to a fitness center and serene walking trails. Experience the ultimate blend of fun and relaxation right here in Tulsa at Polo Run Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Tulsa, OK",
      "seo_description": "Discover apartments with a pool in Tulsa, OK at Polo Run. Spacious homes with great amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-74136",
      "search_query": "fitness center apartments 74136",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in 74136",
      "h2_subtitle": "Experience vibrant living in the 74136 area with apartment amenities including a fitness center at Polo Run Apartments in Tulsa.",
      "page_copy": "For those looking to stay active without leaving home, Polo Run Apartments offers fitness center apartments in the 74136 area code. Our spacious one and two-bedroom layouts are complemented by a well-equipped fitness center, allowing you to maintain your workout routine conveniently.\n\nLocated in South Tulsa, Polo Run Apartments provides a perfect mix of comfort and accessibility, with amenities that extend beyond just a fitness center. Whether it's exploring the nearby walking trails or taking a dip in our pool, Polo Run ensures that you're part of a community that understands the importance of a balanced lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in 74136",
      "seo_description": "Discover fitness center apartments in the 74136 area at Polo Run. Enjoy modern living with excellent amenities in a convenient Tulsa location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "apartments-with-air-conditioning-south-tulsa",
      "search_query": "apartments with air conditioning South Tulsa",
      "category": "Amenity",
      "h1_title": "A/C Apartments in South Tulsa",
      "h2_subtitle": "Live comfortably in South Tulsa with apartments that include air conditioning. Polo Run Apartments offers the perfect climate-controlled homes.",
      "page_copy": "When looking for apartments with air conditioning in South Tulsa, Polo Run Apartments meets all your expectations. Our spacious one and two-bedroom units are designed to provide the utmost comfort, ensuring a cool retreat from the Oklahoma heat.\n\nSituated in the tranquil neighborhood of South Tulsa, Polo Run offers more than just climate-controlled interiors. Our community features amenities such as a refreshing pool, fitness center, and peaceful walking trails. Choose Polo Run Apartments, where you can enjoy a perfect blend of comfort, convenience, and a welcoming atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "A/C Apartments in South Tulsa",
      "seo_description": "Find apartments with air conditioning in South Tulsa at Polo Run. Comfortable living with great amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "dishwasher-equipped-apartments-tulsa",
      "search_query": "dishwasher equipped apartments Tulsa",
      "category": "Amenity",
      "h1_title": "Dishwasher Apartments in Tulsa",
      "h2_subtitle": "Find convenience with dishwasher-equipped apartments in Tulsa at Polo Run. Experience hassle-free living with modern amenities.",
      "page_copy": "Discover the convenience of dishwasher-equipped apartments in Tulsa at Polo Run Apartments. Our spacious one and two-bedroom homes feature modern kitchens that include dishwashers, making clean-up after meals a breeze.\n\nPolo Run Apartments, situated in the vibrant South Tulsa area, provides not only convenient in-home amenities but also community perks like a sparkling pool, fitness center, and scenic walking trails. Enjoy a lifestyle where ease and comfort meet in a beautifully maintained setting. Come see why Polo Run is the preferred choice for contemporary Tulsa living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Apartments in Tulsa",
      "seo_description": "Explore dishwasher-equipped apartments in Tulsa at Polo Run. Enjoy modern living with superior amenities and efficient features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-tulsa",
      "search_query": "one bedroom apartments south tulsa",
      "category": "Floorplan",
      "h1_title": "One-Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Discover stylish one-bedroom apartments in South Tulsa at Polo Run. Enjoy modern comforts in a vibrant community setting.",
      "page_copy": "If you're searching for one-bedroom apartments in South Tulsa, Polo Run Apartments offers a perfect blend of style and convenience. Our thoughtfully designed one-bedroom layouts provide ample living space, ensuring you have a comfortable and cozy home.\n\nNestled in the picturesque South Tulsa neighborhood, Polo Run Apartments boasts a variety of community amenities, including a refreshing pool and a modern fitness center. Plus, with walking trails nearby, you can enjoy the great outdoors right at your doorstep. Experience a welcoming community that caters to your lifestyle needs at Polo Run.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One-Bedroom Apartments in South Tulsa",
      "seo_description": "Explore one-bedroom apartments in South Tulsa at Polo Run. Enjoy a vibrant community with excellent amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-tulsa-ok",
      "search_query": "two bedroom apartments tulsa ok",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments in Tulsa, OK",
      "h2_subtitle": "Spacious two-bedroom apartments in Tulsa, OK await at Polo Run. Experience comfortable living with modern amenities.",
      "page_copy": "Explore the spacious two-bedroom apartments in Tulsa, OK at Polo Run Apartments. Our thoughtfully designed layouts provide a generous living space perfect for families, roommates, or anyone seeking extra room. Enjoy a cozy home that's designed with comfort in mind.\n\nLocated in South Tulsa, Polo Run Apartments offers a range of amenities, including a pool and fitness center, ensuring you have everything you need right at home. With a convenient location that retains a sense of tranquility, Polo Run is the ideal place for those seeking a balanced lifestyle. Discover your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments in Tulsa, OK",
      "seo_description": "Find spacious two-bedroom apartments in Tulsa, OK at Polo Run. Enjoy modern amenities and a convenient location for ideal living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "apartments-near-oral-roberts-university-tulsa",
      "search_query": "apartments near oral roberts university tulsa",
      "category": "School",
      "h1_title": "Apartments Near Oral Roberts University",
      "h2_subtitle": "Discover convenient apartments near Oral Roberts University in Tulsa at Polo Run. Enjoy a comfortable and modern living experience.",
      "page_copy": "Seeking apartments near Oral Roberts University in Tulsa? Polo Run Apartments offers an ideal location for students and faculty, just a short drive from the university. Our community features spacious one and two-bedroom layouts, designed to accommodate a variety of lifestyles.\n\nEnjoy modern amenities such as a refreshing pool and a state-of-the-art fitness center, making it easy to balance work, study, and relaxation. Located in the vibrant South Tulsa area, Polo Run Apartments provides the perfect blend of convenience and comfort, making it an excellent choice for those attending or working at Oral Roberts University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oral Roberts University",
      "seo_description": "Polo Run offers ideal apartments near Oral Roberts University in Tulsa with modern amenities and convenient access to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "apartments-close-to-tulsa-community-college-southeast-campus",
      "search_query": "apartments close to tulsa community college southeast campus",
      "category": "School",
      "h1_title": "Apartments Close to Tulsa Community College",
      "h2_subtitle": "Find comfortable apartments close to Tulsa Community College Southeast Campus at Polo Run. Benefit from a convenient and vibrant living environment.",
      "page_copy": "For those looking for apartments close to Tulsa Community College Southeast Campus, Polo Run Apartments offers an ideal location in South Tulsa. Enjoy the convenience of a short commute coupled with a vibrant community that caters to both students and professionals alike.\n\nAt Polo Run, you'll find spacious one and two-bedroom apartments featuring modern comforts like walk-in closets and fireplaces. Our amenities, which include a pool and a fitness center, support a balanced and enjoyable lifestyle. Experience the ease of living near Tulsa Community College while enjoying a serene home environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close To Tulsa Community College",
      "seo_description": "Discover Polo Run Apartments, close to Tulsa Community College Southeast Campus, offering modern living and great amenities in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "apartments-near-ou-tulsa-south-tulsa",
      "search_query": "apartments near ou-tulsa south tulsa",
      "category": "School",
      "h1_title": "Apartments Near OU-Tulsa in South Tulsa",
      "h2_subtitle": "Explore apartments near OU-Tulsa in South Tulsa at Polo Run. Enjoy a convenient and comfortable lifestyle in a vibrant community.",
      "page_copy": "Polo Run Apartments provides an excellent choice for those seeking apartments near OU-Tulsa in South Tulsa. Our community offers a unique blend of comfort and convenience, perfect for students, faculty, and professionals who wish to stay close to campus while enjoying the benefits of a well-appointed living space.\n\nLocated in a prime spot in South Tulsa, Polo Run delivers spacious one and two-bedroom layouts along with modern amenities like a refreshing pool and fitness center. These features make it easy to maintain a balanced lifestyle whether you're studying or unwinding. Experience the assurance of living near OU-Tulsa with the added comfort of a welcoming apartment community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OU-Tulsa in South Tulsa",
      "seo_description": "Discover Polo Run Apartments near OU-Tulsa in South Tulsa. Enjoy modern living and facilities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "apartments-near-saint-francis-hospital-tulsa",
      "search_query": "apartments near Saint Francis Hospital Tulsa",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Francis Hospital",
      "h2_subtitle": "Discover the convenience of living in apartments near Saint Francis Hospital in Tulsa at Polo Run. Enjoy a comfortable and connected lifestyle.",
      "page_copy": "Polo Run Apartments offers an attractive living option for those seeking apartments near Saint Francis Hospital in Tulsa. Situated conveniently in South Tulsa, our community provides a peaceful retreat with the amenities you need for a balanced lifestyle.\n\nOur spacious one and two-bedroom layouts come equipped with features like walk-in closets and fireplaces, ideal for unwinding after a long day. Residents enjoy access to a refreshing pool, serene walking trails, and a well-equipped fitness center. Choose Polo Run Apartments for a comfortable and convenient residence near Saint Francis Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Francis Hospital Tulsa",
      "seo_description": "Polo Run Apartments near Saint Francis Hospital offers comfort, convenience, and modern amenities in a prime South Tulsa location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "apartments-close-to-ascension-st-john-medical-center-south-tulsa",
      "search_query": "apartments close to Ascension St. John Medical Center South Tulsa",
      "category": "Hospital",
      "h1_title": "Apts Close to Ascension St. John Medical",
      "h2_subtitle": "Discover comfortable living with apartments close to Ascension St. John Medical Center in South Tulsa at Polo Run.",
      "page_copy": "Explore Polo Run Apartments if you're seeking living spaces close to Ascension St. John Medical Center in South Tulsa. Our community delivers modern conveniences and a tranquil environment suited for healthcare professionals and anyone needing quick access to the medical center. \n\nOffering spacious one and two-bedroom layouts, Polo Run Apartments are equipped with fireplaces and walk-in closets. Amenities such as a refreshing pool and a fitness center enhance the community, creating a perfect blend of relaxation and accessibility. Choose Polo Run for a lifestyle that keeps you connected and comfortable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Ascension St. John in South Tulsa",
      "seo_description": "Discover Polo Run Apartments close to Ascension St. John Medical Center, offering comfort and convenience in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "apartments-near-gathering-place-tulsa",
      "search_query": "apartments near Gathering Place Tulsa",
      "category": "Park",
      "h1_title": "Apartments Near Gathering Place Tulsa",
      "h2_subtitle": "Find vibrant living in apartments near Gathering Place, Tulsa at Polo Run. Enjoy both comfort and convenience in a prime location.",
      "page_copy": "For those looking to live near the heart of Tulsa's vibrant urban outdoors, Polo Run Apartments offers the perfect solution with our apartments near Gathering Place Tulsa. Located in the charming South Tulsa neighborhood, our community provides easy access to one of the city's most beloved parks.\n\nBoasting spacious one and two-bedroom layouts, our apartments feature modern amenities like fireplaces and walk-in closets. Residents can relax by the pool or stroll through serene walking trails. Polo Run Apartments combines the peacefulness of home with the excitement of being close to the Gathering Place.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Gathering Place Tulsa",
      "seo_description": "Discover Polo Run Apartments near Gathering Place in Tulsa. Enjoy modern living amidst vibrant outdoor spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "apartments-close-to-woodward-park-and-gardens-74136",
      "search_query": "apartments close to Woodward Park and Gardens 74136",
      "category": "Park",
      "h1_title": "Apts Close to Woodward Park and Gardens",
      "h2_subtitle": "Enjoy serene surroundings with apartments close to Woodward Park and Gardens in the 74136 area, offering comfort and a peaceful lifestyle at Polo Run.",
      "page_copy": "Nestled in the desirable South Tulsa area, Polo Run Apartments offer a convenient location for those looking for apartments close to Woodward Park and Gardens in the 74136 zip code. Our community provides an ideal blend of nature's tranquility and urban convenience.\n\nPolo Run features spacious one and two-bedroom apartments with amenities such as fireplaces, walk-in closets, and balconies. Alongside serene walking trails, our on-site fitness center and refreshing pool add to the pleasures of living here. Experience a lifestyle that nurtures both relaxation and recreation at Polo Run Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Woodward Park and Gardens 74136",
      "seo_description": "Live near Woodward Park and Gardens in 74136. Discover Polo Run Apartments offering comfort in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "rhema-park-nearby-apartments-south-tulsa",
      "search_query": "Rhema Park nearby apartments South Tulsa",
      "category": "Park",
      "h1_title": "Rhema Park Nearby Apartments in South Tulsa",
      "h2_subtitle": "Experience the convenience of Rhema Park nearby apartments in South Tulsa at Polo Run. A perfect blend of serenity and modern living awaits you.",
      "page_copy": "Discover Polo Run Apartments, perfectly situated for those seeking Rhema Park nearby apartments in South Tulsa. Our location offers the unique ability to enjoy the tranquility of park-like settings while being close to the area's vibrant city life.\n\nWith spacious one and two-bedroom layouts, amenities like fireplaces and walk-in closets, and community features including a pool and fitness center, Polo Run Apartments provide a welcoming retreat. Enjoy quiet moments on your balcony or explore our serene walking trails, creating a balanced lifestyle of comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rhema Park Nearby Apartments South Tulsa",
      "seo_description": "Explore Polo Run Apartments near Rhema Park in South Tulsa, offering modern living and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "lafortune-park-adjacent-apartments-tulsa",
      "search_query": "LaFortune Park adjacent apartments Tulsa",
      "category": "Park",
      "h1_title": "LaFortune Park Adjacent Apartments Tulsa",
      "h2_subtitle": "Live next to leisure with LaFortune Park adjacent apartments in Tulsa at Polo Run. Discover spacious living in a prime location.",
      "page_copy": "Situated in South Tulsa, Polo Run Apartments provides an ideal setting for those seeking LaFortune Park adjacent apartments in Tulsa. Enjoy easy access to Tulsa’s popular recreational destination, making outdoor activities convenient and enjoyable.\n\nOur community offers spacious one and two-bedroom apartments with modern features like fireplaces and walk-in closets. With amenities including a refreshing pool and serene walking trails, residents relish a lifestyle of fun and relaxation. Come experience the ease of living next to LaFortune Park at Polo Run Apartments, where community and comfort meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "LaFortune Park Adjacent Apartments Tulsa",
      "seo_description": "Discover Polo Run Apartments adjacent to LaFortune Park in Tulsa, offering modern living and a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165619",
      "source": "generator",
      "page_item_url": "hunter-park-area-apartments-oklahoma",
      "search_query": "Hunter Park area apartments Oklahoma",
      "category": "Park",
      "h1_title": "Hunter Park Area Apartments in Oklahoma",
      "h2_subtitle": "Explore Hunter Park area apartments in Oklahoma at Polo Run. Enjoy a vibrant community with top amenities in South Tulsa.",
      "page_copy": "Polo Run Apartments offer a welcoming home for those seeking Hunter Park area apartments in Oklahoma. Located in the vibrant South Tulsa neighborhood, residents enjoy proximity to the beautiful Hunter Park, ideal for outdoor activities and relaxation.\n\nOur community features spacious one and two-bedroom apartments equipped with modern amenities like fireplaces, walk-in closets, and balconies. Residents can stay active in the fitness center or unwind by the pool. With tranquil walking trails on-site, Polo Run Apartments blend convenience and comfort beautifully for an enriching lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
      "featured_image_media": {
        "alt_text": "Polo Run apartment building exterior with entrance signage",
        "public_id": "019cfb45-6a9d-7499-bcf1-5efeb018fced",
        "storage_key": "property/6767906449165619/019cfb45-6a9d-7499-bcf1-5efeb018fced.webp",
        "width": 1239,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hunter Park Area Apartments Oklahoma",
      "seo_description": "Live near Hunter Park in Oklahoma with Polo Run Apartments, offering comfort and convenience in Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5199"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-1SXGNLC7PX"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151941"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/polo-run/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T7F73J98"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165619/019d1bd9-4e54-70ec-b4cb-82e02613e5ba.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8794409771"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "14c2f588-2128-471c-9937-e47fbab13a09"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-785-1578"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "63c834b2450f820f97414d64"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlJSQkdtcWdRTzdVaUFaSEp6eXd4c1E9PSIsInZhbHVlIjoiWGdOQ1JCUlY4MFh1clpjREZDSTJVZz09IiwibWFjIjoiM2I2NTk3MDcxNzQ0MDE3YWRhMDc1ODk3YzM5ODQzNzE0MzQzMTAyMWVmNjI3Mjg1NTMxYzE3MGQ1ZjNjOWFjNyJ9"
    }
  ],
  "custom_qb_id": "5199",
  "custom_ga4_id": "G-1SXGNLC7PX",
  "custom_repli_id": "10041151941",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/polo-run/register/",
  "custom_google_gtm_id": "GTM-T7F73J98",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165619/019d1bd9-4e54-70ec-b4cb-82e02613e5ba.pdf",
  "custom_hubspot_company_id": "8794409771",
  "custom_rentgrata_property_id": "14c2f588-2128-471c-9937-e47fbab13a09",
  "custom_ppc_tracking_phone_number": "833-785-1578",
  "custom_residentboost_apartment_id": "63c834b2450f820f97414d64",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlJSQkdtcWdRTzdVaUFaSEp6eXd4c1E9PSIsInZhbHVlIjoiWGdOQ1JCUlY4MFh1clpjREZDSTJVZz09IiwibWFjIjoiM2I2NTk3MDcxNzQ0MDE3YWRhMDc1ODk3YzM5ODQzNzE0MzQzMTAyMWVmNjI3Mjg1NTMxYzE3MGQ1ZjNjOWFjNyJ9"
};

export const generatedAt = '2026-08-27T21:37:07.880Z';
